(function () {
  const initializedRoots = new WeakSet();

  function initOwaProductPageReplica(sectionRoot) {
    if (!sectionRoot || initializedRoots.has(sectionRoot)) return;

    const container = sectionRoot.querySelector('[data-owa-product]');
    if (!container) return;

    initializedRoots.add(sectionRoot);

    const productRoot = sectionRoot.querySelector('[data-owa-product-root]');
    const isHighVariantProduct = String(productRoot?.dataset.owaHighVariantProduct || '').toLowerCase() === 'true';
    const productSectionId = productRoot?.dataset.owaSectionId || '';
    const judgeMeReviewsRoot =
      [...document.querySelectorAll('[data-owa-judgeme-reviews-root]')].find((node) => {
        return node.dataset.owaJudgemeReviewsRoot === productSectionId;
      }) || null;
    const reviewScrollTriggers = [...container.querySelectorAll('[data-owa-scroll-reviews]')];
    const variantsNode = sectionRoot.querySelector('[data-owa-variants]');
    const fullVariantsNode = sectionRoot.querySelector('[data-owa-full-variants]');
    const standardSizeValuesNode = sectionRoot.querySelector('[data-owa-standard-size-values]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const fullVariantMatrix = fullVariantsNode ? JSON.parse(fullVariantsNode.textContent || '[]') || [] : [];
    const standardSizeValues = standardSizeValuesNode
      ? JSON.parse(standardSizeValuesNode.textContent || '[]') || []
      : [];
    const variantCatalog = Array.isArray(fullVariantMatrix) && fullVariantMatrix.length ? fullVariantMatrix : variants;
    const hasLocalVariantMatrix = Array.isArray(fullVariantMatrix) && fullVariantMatrix.length > 0;
    const shouldUseHighVariantRefresh = isHighVariantProduct && !hasLocalVariantMatrix;
    const variantInput = container.querySelector('[data-owa-variant-input]');
    const addButton = container.querySelector('[data-owa-add-to-cart]');
    const productForm =
      container.querySelector('form[id^="owa-product-form-"]') ||
      container.querySelector('form[action*="/cart/add"]');
    const productTitleText = sectionRoot.querySelector('.owa-pdp__title')?.textContent?.trim() || document.title;
    const skuEl = container.querySelector('[data-owa-sku]');
    const photoUploadEnabled = String(productRoot?.dataset.owaPhotoUploadEnabled || '').toLowerCase() === 'true';
    const photoUploadRequired = String(productRoot?.dataset.owaPhotoUploadRequired || '').toLowerCase() === 'true';
    const productRatioType = String(productRoot?.dataset.owaProductRatioType || '')
      .trim()
      .toLowerCase();
    const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    const cartJsonAddUrl = cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
    const cartUrl = window.routes?.cart_url || '/cart';
    const addAnotherPhotoUrl = (() => {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      return currentUrl.toString();
    })();
    const activeBodyScrollLocks = new Set();
    let previousBodyOverflowStyle = null;
    const lockBodyScroll = (source) => {
      if (!source) return;
      if (!activeBodyScrollLocks.size) {
        previousBodyOverflowStyle = document.body.style.overflow || '';
      }
      activeBodyScrollLocks.add(source);
      document.body.style.overflow = 'hidden';
    };
    const unlockBodyScroll = (source) => {
      if (source) {
        activeBodyScrollLocks.delete(source);
      }
      if (activeBodyScrollLocks.size || previousBodyOverflowStyle === null) return;
      document.body.style.overflow = previousBodyOverflowStyle;
      previousBodyOverflowStyle = null;
    };
    const getPickerModalLockKey = (modal) => `picker-modal:${modal?.dataset.owaPickerKey || 'default'}`;

    /* ── Gallery images for lightbox ── */
    const galleryItems = [...container.querySelectorAll('[data-gallery-img]')];
    const imageUrls = galleryItems.map(el => el.dataset.imgUrl);

    /* ── Lightbox ── */
    const lightbox = sectionRoot.querySelector('[data-owa-lightbox]');
    const lightboxImg = lightbox?.querySelector('[data-lightbox-img]');
    const lightboxClose = lightbox?.querySelector('[data-lightbox-close]');
    const lightboxPrev = lightbox?.querySelector('[data-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-lightbox-next]');
    let currentLightboxIndex = 0;

    const openLightbox = (index) => {
      if (!lightbox || !imageUrls.length) return;
      currentLightboxIndex = index;
      lightboxImg.src = imageUrls[index];
      lightboxImg.alt = galleryItems[index]?.querySelector('img')?.alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      lockBodyScroll('gallery-lightbox');
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('gallery-lightbox');
    };

    const navLightbox = (dir) => {
      currentLightboxIndex = (currentLightboxIndex + dir + imageUrls.length) % imageUrls.length;
      lightboxImg.src = imageUrls[currentLightboxIndex];
      lightboxImg.alt = galleryItems[currentLightboxIndex]?.querySelector('img')?.alt || '';
    };

    galleryItems.forEach((item, i) => {
      item.addEventListener('click', () => openLightbox(i));
    });

    lightboxClose?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
    lightboxPrev?.addEventListener('click', (e) => { e.stopPropagation(); navLightbox(-1); });
    lightboxNext?.addEventListener('click', (e) => { e.stopPropagation(); navLightbox(1); });

    reviewScrollTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const targetId = trigger.dataset.owaScrollReviews;
        const target =
          (targetId && document.getElementById(targetId)) ||
          judgeMeReviewsRoot?.querySelector('.owa-pdp__reviews-heading');

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.addEventListener('keydown', (e) => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navLightbox(-1);
      if (e.key === 'ArrowRight') navLightbox(1);
    });

    /* ── Video play/pause ── */
    const videoWrap = container.querySelector('[data-owa-video]');
    if (videoWrap) {
      const video = videoWrap.querySelector('video');
      const toggleBtn = videoWrap.querySelector('[data-video-toggle]');
      if (video && toggleBtn) {
        const playSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>';
        const pauseSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg>';

        videoWrap.addEventListener('click', (e) => {
          e.stopPropagation();
          if (video.paused) {
            video.play();
            toggleBtn.innerHTML = pauseSvg;
          } else {
            video.pause();
            toggleBtn.innerHTML = playSvg;
          }
        });
      }
    }

    /* ── Variant + option logic ── */
    const optionGroups = [...container.querySelectorAll('[data-option-index]')];
    const optionButtons = [...sectionRoot.querySelectorAll('[data-option-value], [data-owa-option-value]')];
    const optionNamesNode = sectionRoot.querySelector('[data-owa-option-names]');
    let optionNames = [];

    try {
      optionNames = optionNamesNode ? JSON.parse(optionNamesNode.textContent) : [];
    } catch (e) {
      optionNames = [];
      void e;
    }

    if (!optionNames.length && variantCatalog[0]?.options?.length) {
      optionNames = variantCatalog[0].options.map((_, i) => `option_${i}`);
    }

    const selectedOptionsByName = {};
    const initialVariantId = Number(variantInput?.value || 0);
    const initialVariant =
      variantCatalog.find((v) => Number(v.id) === initialVariantId) ||
      variantCatalog.find((v) => v.available) ||
      variantCatalog[0];

    if (!shouldUseHighVariantRefresh && initialVariant && optionNames.length) {
      optionNames.forEach((name, index) => {
        selectedOptionsByName[name] = initialVariant.options[index];
      });
    }

    const selectedOptionValueIdsByName = {};
    const selectedOptionProductUrlsByName = {};
    const getNodesInSectionAndDocument = (selector) => {
      const sectionNodes = [...sectionRoot.querySelectorAll(selector)];
      const documentNodes = [...document.querySelectorAll(selector)];
      return [...new Set([...sectionNodes, ...documentNodes])];
    };

    const getButtonOptionName = (btn) => {
      if (btn.dataset.owaOptionName) return btn.dataset.owaOptionName;
      const group = btn.closest('[data-owa-option-name]');
      if (group?.dataset.owaOptionName) return group.dataset.owaOptionName;
      const groupIndex = btn.closest('[data-option-index]')?.dataset.optionIndex;
      if (groupIndex != null) return optionNames[Number(groupIndex)];
      return '';
    };

    const getButtonOptionValue = (btn) =>
      btn.dataset.owaOptionValue || btn.dataset.optionValue || btn.dataset.owaMaterialValue || btn.dataset.owaSizeValue || '';

    const getSelectedOptionNodes = (optionName) => {
      if (!optionName) return [];
      return getNodesInSectionAndDocument('[data-owa-option-name]').filter((node) => {
        if (node.dataset.owaOptionName !== optionName) return false;
        if (!getButtonOptionValue(node)) return false;
        return node.classList.contains('is-active') || node.classList.contains('is-selected');
      });
    };

    const getPreferredSelectedOptionNode = (optionName) => {
      const selectedNodes = getSelectedOptionNodes(optionName);
      if (!selectedNodes.length) return null;
      return (
        selectedNodes.find((node) => node.hasAttribute('data-owa-list-color-button')) ||
        selectedNodes.find((node) => !node.hasAttribute('data-owa-list-segment')) ||
        selectedNodes[0]
      );
    };

    const rebuildSelectedOptionsByNameFromDom = () => {
      optionNames.forEach((optionName) => {
        const selectedNode = getPreferredSelectedOptionNode(optionName);
        if (!selectedNode) return;
        const selectedValue = getButtonOptionValue(selectedNode);
        if (selectedValue) selectedOptionsByName[optionName] = selectedValue;
      });
    };

    const rememberOptionValueMetadata = (optionName, button) => {
      if (!optionName || !button) return;
      const optionValueId = button.dataset.owaOptionValueId || '';
      const productUrl = button.dataset.productUrl || '';
      if (optionValueId) selectedOptionValueIdsByName[optionName] = optionValueId;
      if (productUrl) selectedOptionProductUrlsByName[optionName] = productUrl;
    };

    const rebuildSelectedOptionValueMetadata = () => {
      if (!optionNames.length) return;
      optionNames.forEach((optionName) => {
        const selectedNode = getPreferredSelectedOptionNode(optionName);
        rememberOptionValueMetadata(optionName, selectedNode);
      });
    };

    const getControlMeta = (optionName, optionValue, fallbackButton) => {
      const matchedButton =
        fallbackButton ||
        optionButtons.find((button) => getButtonOptionName(button) === optionName && getButtonOptionValue(button) === optionValue);
      return {
        title: matchedButton?.dataset.owaMetaTitle || optionValue,
        description: matchedButton?.dataset.owaMetaDescription || '',
        image: matchedButton?.dataset.owaMetaImage || '',
        badge: matchedButton?.dataset.owaMetaBadge || '',
      };
    };

    const parseSizeValue = (value) => {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
      if (!match) return null;

      const width = Number(match[1].replace(',', '.'));
      const height = Number(match[2].replace(',', '.'));
      if (!width || !height) return null;

      const normalizedRatio = Math.max(width, height) / Math.min(width, height);
      const ratioType = getPhotoRatioType(width, height);
      const ratioBucket = getPhotoRatioBucket(width, height);
      return {
        width,
        height,
        aspectRatio: width / height,
        normalizedRatio,
        ratioType,
        ratioBucket,
        isSquare: ratioType === 'square',
      };
    };

    const getSizeDisplayMeta = (value, options = {}) => {
      const rawValue = String(value || '').trim();
      const parsed = parseSizeValue(rawValue);
      if (!parsed) {
        return {
          label: rawValue,
          description: '',
        };
      }

      const suffix = rawValue.replace(/^\s*\d+(?:[.,]\d+)?\s*x\s*\d+(?:[.,]\d+)?\s*(?:cm)?/i, '').trim();
      const suffixText = suffix ? ` ${suffix}` : '';
      const preserveOrientation = options.preserveOrientation === true;
      const activeDisplayRatioType =
        photoSelection?.ratioType || (!photoUploadEnabled ? productRatioType : '') || '';
      const shouldSwapForDisplay =
        !preserveOrientation &&
        !parsed.isSquare &&
        ((activeDisplayRatioType === 'landscape' && parsed.width < parsed.height) ||
          (activeDisplayRatioType === 'portrait' && parsed.width > parsed.height));
      const displayWidth = shouldSwapForDisplay ? parsed.height : parsed.width;
      const displayHeight = shouldSwapForDisplay ? parsed.width : parsed.height;

      return {
        label: `${displayWidth} x ${displayHeight} cm${suffixText}`,
        description: `${displayWidth} cm breedte, ${displayHeight} cm hoogte`,
      };
    };

    const preferredSizeByRatioType = {
      portrait: { width: 40, height: 50 },
      landscape: { width: 50, height: 40 },
      square: { width: 40, height: 40 },
    };

    const getPreferredSizeSpec = (photo) => {
      if (!photo || isUnconventionalRatioBucket(photo.ratioBucket)) return null;
      return preferredSizeByRatioType[String(photo.ratioType || '').toLowerCase()] || null;
    };

    const getDetailDisplayMeta = (value) => {
      const rawValue = String(value || '').trim();
      if (!rawValue) {
        return {
          title: '',
          note: '',
          fullLabel: '',
        };
      }

      const match = rawValue.match(/^([^()]+?)(?:\s*\(([^)]+)\))?$/);
      const title = match?.[1]?.trim() || rawValue;
      const note = match?.[2]?.trim() || '';

      return {
        title,
        note,
        fullLabel: rawValue,
      };
    };

    const getPhotoRatioBucket = (width, height) => {
      const normalizedRatio = Math.max(width, height) / Math.min(width, height);
      if (Math.abs(normalizedRatio - 1) <= 0.08) return 'square';

      if (width > height) {
        const aspectRatio = width / height;
        if (aspectRatio >= 3) return 'panorama';
        if (aspectRatio >= 1.9) return 'wide_landscape';
        return 'landscape';
      }

      const inverseAspectRatio = height / width;
      if (inverseAspectRatio >= 3) return 'ultra_tall';
      if (inverseAspectRatio >= 1.9) return 'tall_portrait';
      return 'portrait';
    };

    const getPhotoRatioType = (width, height) => {
      const ratioBucket = getPhotoRatioBucket(width, height);
      if (ratioBucket === 'square') return 'square';
      if (ratioBucket === 'landscape' || ratioBucket === 'wide_landscape' || ratioBucket === 'panorama') {
        return 'landscape';
      }
      return 'portrait';
    };

    const getPhotoRatioLabel = (ratioBucketOrType) => {
      switch (ratioBucketOrType) {
        case 'square':
          return 'vierkante foto';
        case 'wide_landscape':
          return 'extra brede foto';
        case 'panorama':
          return 'panoramafoto';
        case 'landscape':
          return 'liggende foto';
        case 'tall_portrait':
          return 'extra hoge foto';
        case 'ultra_tall':
          return 'zeer hoge foto';
        default:
          return 'staande foto';
      }
    };

    const isUnconventionalRatioBucket = (ratioBucket) =>
      ['wide_landscape', 'panorama', 'tall_portrait', 'ultra_tall'].includes(String(ratioBucket || ''));

    const getCropRiskMeta = (sourceAspectRatio, targetAspectRatio) => {
      const source = Number(sourceAspectRatio || 0);
      const target = Number(targetAspectRatio || 0);
      if (!source || !target) {
        return {
          score: Number.POSITIVE_INFINITY,
          percent: null,
          level: '',
          label: '',
        };
      }

      const score = 1 - Math.min(source, target) / Math.max(source, target);
      const percent = Math.max(0, Math.round(score * 100));

      if (score <= 0.12) {
        return { score, percent, level: 'goed', label: '' };
      }
      if (score <= 0.28) {
        return { score, percent, level: 'laag', label: 'Kleine uitsnede mogelijk' };
      }
      if (score <= 0.45) {
        return { score, percent, level: 'middel', label: 'Merkbare uitsnede mogelijk' };
      }
      return { score, percent, level: 'hoog', label: 'Grote uitsnede mogelijk' };
    };

    const readImageDimensions = (file) =>
      new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve({
            width: image.naturalWidth,
            height: image.naturalHeight,
          });
        };

        image.onerror = (error) => {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        };

        image.src = objectUrl;
      });

    const setFormattedSizeLabel = (node, value, options = {}) => {
      if (!node) return;
      node.textContent = getSizeDisplayMeta(value, options).label || String(value || '');
    };

    const syncGroupStates = () => {
      optionGroups.forEach((group) => {
        const groupIndex = Number(group.dataset.optionIndex || -1);
        const optionName = group.dataset.owaOptionName || optionNames[groupIndex];
        if (!optionName) return;
        const selectedValue = selectedOptionsByName[optionName];
        const labelValue = group.querySelector('[data-owa-current]');
        if (labelValue) labelValue.textContent = selectedValue || '';
        group.querySelectorAll('[data-option-value], [data-owa-option-value]').forEach((button) => {
          button.classList.toggle('is-active', getButtonOptionValue(button) === selectedValue);
          button.classList.toggle('is-selected', getButtonOptionValue(button) === selectedValue);
        });
      });

      optionButtons.forEach((button) => {
        const optionName = getButtonOptionName(button);
        const selectedValue = selectedOptionsByName[optionName];
        const isActive = !!optionName && getButtonOptionValue(button) === selectedValue;
        button.classList.toggle('is-active', isActive);
        button.classList.toggle('is-selected', isActive);
      });
    };

    const syncPickerCards = (optionName, optionValue, sourceButton) => {
      if (!optionName) return;
      const meta = getControlMeta(optionName, optionValue, sourceButton);
      sectionRoot.querySelectorAll('[data-owa-picker-current]').forEach((node) => {
        if (node.dataset.owaOptionName === optionName) node.textContent = meta.title || optionValue;
      });
      sectionRoot.querySelectorAll('[data-owa-picker-description]').forEach((node) => {
        if (node.dataset.owaOptionName === optionName) {
          node.textContent = meta.description || '';
          node.classList.toggle('is-empty', !meta.description);
        }
      });
      sectionRoot.querySelectorAll('[data-owa-picker-badge]').forEach((node) => {
        if (node.dataset.owaOptionName === optionName) {
          node.textContent = meta.badge || '';
          node.classList.toggle('is-hidden', !meta.badge);
        }
      });
      sectionRoot.querySelectorAll('[data-owa-picker-image]').forEach((node) => {
        if (node.dataset.owaOptionName === optionName) {
          if (meta.image) {
            node.src = meta.image;
            node.alt = meta.title || optionValue;
            node.classList.remove('is-hidden');
          } else {
            node.classList.add('is-hidden');
          }
        }
      });
      sectionRoot.querySelectorAll('[data-owa-picker-image-placeholder]').forEach((node) => {
        if (node.dataset.owaOptionName === optionName) {
          node.classList.toggle('is-hidden', !!meta.image);
        }
      });
    };

    const currencyFormat = productRoot?.dataset.owaMoneyFormat || '{{amount}}';

    const formatMoney = (cents) => {
      const raw = Number(cents || 0) / 100;
      const withDec = raw.toFixed(2);
      const withComma = withDec.replace('.', ',');
      const noDecimals = Math.round(raw).toString();
      return currencyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, withDec);
    };

    const ctaText = productRoot?.dataset.owaCtaText || window.variantStrings?.addToCart || '';
    const unavailableText = productRoot?.dataset.owaCtaUnavailable || window.variantStrings?.unavailable || '';
    const soldOutText = productRoot?.dataset.owaCtaSoldOut || window.variantStrings?.soldOut || '';
    const skuPrefix = productRoot?.dataset.owaSkuPrefix || '';

    const priceContainer = sectionRoot.querySelector('[data-owa-price]');
    const currentPriceEl = priceContainer?.querySelector('[data-owa-current-price]');
    const comparePriceEl = priceContainer?.querySelector('[data-owa-compare-price]');
    const priceBadgeEl = priceContainer?.querySelector('.owa-pdp__price-badge');

    const stickyPriceEl = sectionRoot.querySelector('[data-owa-sticky-price]');
    const stickyCompareEl = sectionRoot.querySelector('[data-owa-sticky-compare]');
    const stickyBadgeEl = sectionRoot.querySelector('[data-owa-sticky-badge]');

    const updatePriceDisplay = (currentCents, variant) => {
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(currentCents);
      const compareAt = Number(variant?.compare_at_price || 0);
      if (compareAt && compareAt > currentCents) {
        const pct = Math.round(((compareAt - currentCents) / compareAt) * 100);
        if (comparePriceEl) {
          comparePriceEl.textContent = formatMoney(compareAt);
          comparePriceEl.style.display = '';
        }
        if (priceBadgeEl) {
          priceBadgeEl.textContent = '-' + pct + '%';
          priceBadgeEl.style.display = '';
        }
        if (stickyCompareEl) {
          stickyCompareEl.textContent = formatMoney(compareAt);
          stickyCompareEl.style.display = '';
        }
        if (stickyBadgeEl) {
          stickyBadgeEl.textContent = '-' + pct + '%';
          stickyBadgeEl.style.display = '';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (priceBadgeEl) priceBadgeEl.style.display = 'none';
        if (stickyCompareEl) stickyCompareEl.style.display = 'none';
        if (stickyBadgeEl) stickyBadgeEl.style.display = 'none';
      }
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(currentCents);
    };

    const resolveVariant = (selectionOverrides = {}) => {
      if (!variantCatalog.length) return null;
      return variantCatalog.find((variant) =>
        optionNames.every((optionName, index) => {
          const selectedValue = Object.prototype.hasOwnProperty.call(selectionOverrides, optionName)
            ? selectionOverrides[optionName]
            : selectedOptionsByName[optionName];
          return !selectedValue || variant.options[index] === selectedValue;
        })
      );
    };

    const setVariantUI = (variant) => {
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = unavailableText;
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? ctaText : soldOutText;
      }
      updatePriceDisplay(Number(variant.price || 0), variant);
      if (skuEl) skuEl.textContent = variant.sku ? `${skuPrefix}: ${variant.sku}` : '';
    };

    let updateFrameOptionsVisibility = () => {};
    let syncListInlineState = () => {};
    let syncSizeLineItemInputs = () => {};
    let syncDetailLineItemInput = () => {};
    let syncDetailCardsForContext = () => {};
    let syncUpsellDetailSummary = () => {};

    const sectionId =
      productRoot?.dataset.owaSectionId ||
      sectionRoot.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');
    const sectionContainer =
      (sectionId && document.getElementById(`shopify-section-${sectionId}`)) ||
      sectionRoot.closest('[id^="shopify-section-"]');
    let highVariantAbortController = null;

    const refreshHighVariantSection = async (preferredProductUrl) => {
      if (!shouldUseHighVariantRefresh || !sectionId || !sectionContainer) return false;

      const selectedOptionValueIds = optionNames
        .map((optionName) => selectedOptionValueIdsByName[optionName])
        .filter(Boolean);

      if (!selectedOptionValueIds.length) return false;

      const currentUrl = new URL(window.location.href);
      const baseProductUrl = preferredProductUrl || currentUrl.pathname;
      const requestUrl = new URL(baseProductUrl, window.location.origin);
      const previewThemeId = currentUrl.searchParams.get('preview_theme_id');

      if (previewThemeId) requestUrl.searchParams.set('preview_theme_id', previewThemeId);
      requestUrl.searchParams.set('section_id', sectionId);
      requestUrl.searchParams.set('option_values', selectedOptionValueIds.join(','));

      highVariantAbortController?.abort();
      highVariantAbortController = new AbortController();

      const response = await fetch(requestUrl.toString(), {
        signal: highVariantAbortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Failed to refresh section (${response.status})`);

      const html = await response.text();
      if (!html) throw new Error('Empty section response');

      sectionContainer.innerHTML = html;
      initWithin(sectionContainer);

      const nextUrl = new URL(requestUrl.toString());
      nextUrl.searchParams.delete('section_id');
      window.history.replaceState({}, '', nextUrl.toString());

      return true;
    };

    const syncSelectionUi = (optionName, optionValue, sourceButton) => {
      syncGroupStates();
      syncPickerCards(optionName, optionValue, sourceButton);
      updateFrameOptionsVisibility();
      syncListInlineState();
      syncSizeLineItemInputs();
      syncDetailLineItemInput();
      syncDetailCardsForContext();
      syncUpsellDetailSummary();
    };

    const applyOptionSelection = async (optionName, optionValue, sourceButton) => {
      if (!optionName) return;

      const previousValue = selectedOptionsByName[optionName];
      const isSameSelection = previousValue === optionValue;

      selectedOptionsByName[optionName] = optionValue;
      rememberOptionValueMetadata(optionName, sourceButton);

      if (shouldUseHighVariantRefresh) {
        syncSelectionUi(optionName, optionValue, sourceButton);
        if (isSameSelection) return;

        const preferredProductUrl = sourceButton?.dataset?.productUrl || selectedOptionProductUrlsByName[optionName];
        try {
          await refreshHighVariantSection(preferredProductUrl);
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.warn('OWA PDP high-variant refresh failed', error);
          }
        }
        return;
      }

      if (isSameSelection) {
        syncSelectionUi(optionName, optionValue, sourceButton);
        return;
      }

      syncGroupStates();
      syncPickerCards(optionName, optionValue, sourceButton);
      const variant = resolveVariant();
      setVariantUI(variant || initialVariant || variantCatalog[0]);
      updateFrameOptionsVisibility();
      syncListInlineState();
      syncSizeLineItemInputs();
      if (materialOptionName && optionName === materialOptionName) {
        if (customSizeMaterialInput) customSizeMaterialInput.value = optionValue;
        syncCustomSizeLeadFields();
      }
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.hasAttribute('data-owa-list-segment')) return;

        const optionName = getButtonOptionName(button);
        const optionValue = getButtonOptionValue(button);
        if (!optionName || !optionValue) return;
        await applyOptionSelection(optionName, optionValue, button);
        const modal = button.closest('[data-owa-picker-modal]');
        if (modal) {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          unlockBodyScroll(getPickerModalLockKey(modal));
        }
      });
    });

    if (shouldUseHighVariantRefresh) rebuildSelectedOptionsByNameFromDom();
    syncGroupStates();
    optionNames.forEach((optionName) => {
      const selectedValue = selectedOptionsByName[optionName];
      if (selectedValue) syncPickerCards(optionName, selectedValue, null);
    });
    if (shouldUseHighVariantRefresh) rebuildSelectedOptionValueMetadata();

    const queryInSectionOrDocument = (selector) => sectionRoot.querySelector(selector) || document.querySelector(selector);
    const queryAllInSectionAndDocument = (selector) => {
      const sectionNodes = [...sectionRoot.querySelectorAll(selector)];
      const documentNodes = [...document.querySelectorAll(selector)];
      return [...new Set([...sectionNodes, ...documentNodes])];
    };

    /* ── Generic picker modals ── */
    const pickerModals = queryAllInSectionAndDocument('[data-owa-picker-modal]');
    const openPickerModalByKey = (pickerKey) => {
      if (!pickerKey) return;
      const modal = pickerModals.find((node) => node.dataset.owaPickerKey === pickerKey);
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockBodyScroll(getPickerModalLockKey(modal));
    };

    const closePickerModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll(getPickerModalLockKey(modal));
    };

    sectionRoot.querySelectorAll('[data-owa-picker-open]').forEach((button) => {
      button.addEventListener('click', () => {
        openPickerModalByKey(button.dataset.owaPickerOpen);
      });
    });

    queryAllInSectionAndDocument('[data-owa-picker-close]').forEach((button) => {
      button.addEventListener('click', () => {
        closePickerModal(button.closest('[data-owa-picker-modal]'));
      });
    });

    pickerModals.forEach((modal) => {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closePickerModal(modal);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      pickerModals.forEach((modal) => {
        if (modal.classList.contains('is-open')) closePickerModal(modal);
      });
    });

    /* ── Material Picker Modal ── */
    const materialModal = queryInSectionOrDocument('[data-owa-material-modal]');
    const materialOpenBtns = [...sectionRoot.querySelectorAll('[data-owa-material-open]')];
    const materialCloseBtns = [...(materialModal?.querySelectorAll('[data-owa-material-close]') || [])];
    const materialOptions = [...(materialModal?.querySelectorAll('[data-owa-material-value]') || [])];
    const materialPicker = sectionRoot.querySelector('[data-owa-material-picker]');
    const materialOptionName =
      materialPicker?.dataset.owaMaterialOptionName ||
      materialModal?.dataset.owaMaterialOptionName ||
      optionNames[0];
    const materialCardName = sectionRoot.querySelector('[data-owa-material-card-name]');
    const materialCardDesc = sectionRoot.querySelector('[data-owa-material-card-desc]');
    const materialCardImg = sectionRoot.querySelector('[data-owa-material-card-img]');

    const openMaterialModal = () => {
      if (!materialModal) return;
      materialModal.classList.add('is-open');
      materialModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll('material-modal');
    };

    const closeMaterialModal = () => {
      if (!materialModal) return;
      materialModal.classList.remove('is-open');
      materialModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('material-modal');
    };

    materialOpenBtns.forEach(btn => btn.addEventListener('click', openMaterialModal));
    materialCloseBtns.forEach((btn) => btn.addEventListener('click', closeMaterialModal));
    materialModal?.addEventListener('click', (e) => { if (e.target === materialModal) closeMaterialModal(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && materialModal?.classList.contains('is-open')) closeMaterialModal();
    });

    materialOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        const value = opt.dataset.owaMaterialValue;
        const desc = opt.dataset.materialDesc || '';
        const img = opt.dataset.materialImg || '';

        /* Update selected state in modal */
        materialOptions.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        /* Update compact card */
        if (materialCardName) materialCardName.textContent = value;
        if (materialCardDesc) materialCardDesc.textContent = desc;
        if (materialCardImg) {
          if (img) {
            if (materialCardImg.tagName === 'IMG') {
              materialCardImg.src = img;
              materialCardImg.alt = value;
            } else {
              const newImg = document.createElement('img');
              newImg.src = img;
              newImg.alt = value;
              newImg.className = 'owa-pdp__material-card-img';
              newImg.setAttribute('data-owa-material-card-img', '');
              materialCardImg.replaceWith(newImg);
            }
          }
        }

        /* Sync with option controls */
        if (materialOptionName) applyOptionSelection(materialOptionName, value, opt);

        /* Update hidden material field in custom size form */
        if (customSizeMaterialInput) customSizeMaterialInput.value = value;
        syncCustomSizeLeadFields();

        closeMaterialModal();
      });
    });

    /* ── Size Picker + Modal ── */
    const sizeCardName = sectionRoot.querySelector('[data-owa-size-card-name]');
    const sizeOpenBtns = [...sectionRoot.querySelectorAll('[data-owa-size-open]')];
    const sizeModal = queryInSectionOrDocument('[data-owa-size-modal]');
    const sizeCloseBtns = [...(sizeModal?.querySelectorAll('[data-owa-size-close]') || [])];
    const sizeOptions = [...(sizeModal?.querySelectorAll('[data-owa-size-value]') || [])];
    const sizeList = sizeModal?.querySelector('.owa-pdp__size-modal-list');
    const sizeMoreToggle = sizeModal?.querySelector('[data-owa-size-more-toggle]') || null;
    const sizeTabsWrap = sizeModal?.querySelector('.owa-pdp__size-modal-tabs') || null;
    const sizePicker = sectionRoot.querySelector('[data-owa-size-picker]');
    const sizeMatchSummary = sectionRoot.querySelector('[data-owa-size-match-summary]');
    const photoFilterSummary = sizeModal?.querySelector('[data-owa-photo-filter-summary]');
    const photoUploadRoot = sectionRoot.querySelector('[data-owa-photo-upload-root]');
    const photoInput = photoUploadRoot?.querySelector('[data-owa-photo-input]') || null;
    const photoStatus = photoUploadRoot?.querySelector('[data-owa-photo-status]') || null;
    const photoMeta = photoUploadRoot?.querySelector('[data-owa-photo-meta]') || null;
    const photoPreviewRoot = photoUploadRoot?.querySelector('[data-owa-photo-preview-root]') || null;
    const photoPreviewImage = photoPreviewRoot?.querySelector('[data-owa-photo-preview-image]') || null;
    const photoPreviewCaption = photoUploadRoot?.querySelector('[data-owa-photo-preview-caption]') || null;
    const photoCardTitle = photoUploadRoot?.querySelector('[data-owa-photo-card-title]') || null;
    const photoCardSubtitle = photoUploadRoot?.querySelector('[data-owa-photo-card-subtitle]') || null;
    const photoPlaceholder = photoUploadRoot?.querySelector('[data-owa-photo-placeholder]') || null;
    const photoPreviewOpenBtn = photoUploadRoot?.querySelector('[data-owa-photo-preview-open]') || null;
    const uploadLightbox = sectionRoot.querySelector('[data-owa-upload-lightbox]') || null;
    const uploadLightboxImage = uploadLightbox?.querySelector('[data-owa-upload-lightbox-image]') || null;
    const uploadLightboxCloseBtn = uploadLightbox?.querySelector('[data-owa-upload-lightbox-close]') || null;
    const modalPhotoPreviewRoot = sizeModal?.querySelector('[data-owa-photo-modal-preview]') || null;
    const modalPhotoPreviewImage = modalPhotoPreviewRoot?.querySelector('[data-owa-photo-modal-preview-image]') || null;
    const detailStep = sizeModal?.querySelector('[data-owa-detail-step]') || null;
    const detailCards = [...(detailStep?.querySelectorAll('[data-owa-detail-card]') || [])];
    const detailBackBtn = detailStep?.querySelector('[data-owa-detail-back]') || null;
    const detailInfoOpenBtn = detailStep?.querySelector('[data-owa-detail-info-open]') || null;
    const detailSizeLabel = detailStep?.querySelector('[data-owa-detail-size-label]') || null;
    const detailSummaryThumb = detailStep?.querySelector('[data-owa-detail-summary-thumb]') || null;
    const detailSummaryImage = detailStep?.querySelector('[data-owa-detail-summary-image]') || null;
    const detailInfoModal = queryInSectionOrDocument('[data-owa-detail-info-modal]');
    const detailInfoCloseBtns = [...(detailInfoModal?.querySelectorAll('[data-owa-detail-info-close]') || [])];
    const upsellStep = sizeModal?.querySelector('[data-owa-upsell-step]') || null;
    const upsellCards = [...(upsellStep?.querySelectorAll('[data-owa-upsell-card]') || [])];
    const upsellToggles = [...(upsellStep?.querySelectorAll('[data-owa-upsell-toggle]') || [])];
    const upsellBackBtn = upsellStep?.querySelector('[data-owa-upsell-back]') || null;
    const upsellAddAnotherBtn = upsellStep?.querySelector('[data-owa-upsell-add-another]') || null;
    const upsellSubmitBtn = upsellStep?.querySelector('[data-owa-upsell-submit]') || null;
    const upsellError = upsellStep?.querySelector('[data-owa-upsell-error]') || null;
    const upsellSizeLabel = upsellStep?.querySelector('[data-owa-upsell-size-label]') || null;
    const upsellSizePrice = upsellStep?.querySelector('[data-owa-upsell-size-price]') || null;
    const upsellDetailLabel = upsellStep?.querySelector('[data-owa-upsell-detail-label]') || null;
    const upsellSummaryThumb = upsellStep?.querySelector('[data-owa-upsell-summary-thumb]') || null;
    const upsellSummaryImage = upsellStep?.querySelector('[data-owa-upsell-summary-image]') || null;
    const selectedSizeInput = sectionRoot.querySelector('[data-owa-selected-size-input]');
    const selectedDetailInput = sectionRoot.querySelector('[data-owa-detail-level-input]');
    const sizeModeInput = sectionRoot.querySelector('[data-owa-size-mode-input]');
    const photoRatioInput = sectionRoot.querySelector('[data-owa-photo-ratio-input]');
    const photoRatioBucketInput = sectionRoot.querySelector('[data-owa-photo-ratio-bucket-input]');
    const photoAspectRatioInput = sectionRoot.querySelector('[data-owa-photo-aspect-ratio-input]');
    const photoWidthInput = sectionRoot.querySelector('[data-owa-photo-width-input]');
    const photoHeightInput = sectionRoot.querySelector('[data-owa-photo-height-input]');
    const photoFileNameInput = sectionRoot.querySelector('[data-owa-photo-file-name-input]');
    const customSizePanelRoot = sizeModal?.querySelector('[data-owa-size-panel="custom"]') || null;
    const customSizePanel = customSizePanelRoot?.querySelector('[data-owa-custom-size-panel]') || null;
    const customSizeLeadForm = queryInSectionOrDocument('#OwaCustomSizeForm');
    const customSizeWidthInput =
      customSizePanelRoot?.querySelector('[data-owa-custom-width]') ||
      customSizeLeadForm?.querySelector('[data-owa-custom-width]') ||
      null;
    const customSizeHeightInput =
      customSizePanelRoot?.querySelector('[data-owa-custom-height]') ||
      customSizeLeadForm?.querySelector('[data-owa-custom-height]') ||
      null;
    const customSizeMaterialInput = customSizeLeadForm?.querySelector('[data-owa-custom-material]') || null;
    const customSizeRequestedSizeInput = customSizeLeadForm?.querySelector('[data-owa-custom-requested-size]') || null;
    const customSizePhotoUploadedInput = customSizeLeadForm?.querySelector('[data-owa-custom-photo-uploaded]') || null;
    const customSizePhotoNameInput = customSizeLeadForm?.querySelector('[data-owa-custom-photo-name]') || null;
    const customSizePhotoDimensionsInput = customSizeLeadForm?.querySelector('[data-owa-custom-photo-dimensions]') || null;
    const customSizePhotoRatioInput = customSizeLeadForm?.querySelector('[data-owa-custom-photo-ratio]') || null;
    const customSizePhotoFileInput = customSizeLeadForm?.querySelector('[data-owa-custom-photo-file]') || null;
    const customSizeLeadSubmitBtn = customSizeLeadForm?.querySelector('[data-owa-custom-size-submit]') || null;
    const customSizeContinueBtn = customSizePanel?.querySelector('[data-owa-custom-size-continue]') || null;
    const customSizeError = customSizePanel?.querySelector('[data-owa-custom-size-error]') || null;
    const selectedSizeRatioInput = sectionRoot.querySelector('[data-owa-selected-size-ratio-input]');
    const cropRiskLevelInput = sectionRoot.querySelector('[data-owa-crop-risk-level-input]');
    const cropRiskPercentInput = sectionRoot.querySelector('[data-owa-crop-risk-percent-input]');
    const sizeOptionName =
      sizePicker?.dataset.owaSizeOptionName ||
      sizeModal?.dataset.owaSizeOptionName ||
      optionNames[1];
    const sizeOptionIndex = Number(
      sizePicker?.dataset.owaSizeOptionIndex ??
      sizeModal?.dataset.owaSizeOptionIndex ??
      -1
    );
    const detailOptionName =
      sizeModal?.dataset.owaDetailOptionName ||
      optionNames.find((name) => /details|detailniveau|aantal kleuren/i.test(String(name || ''))) ||
      optionNames[2];
    const photoEmptyPrompt = photoUploadRequired
      ? 'Upload eerst je foto om passende maten te zien.'
      : 'Upload je foto om passende maten te zien.';
    const sizeVisibleLimit = 5;
    const standardSizeValueSet = new Set(
      (Array.isArray(standardSizeValues) ? standardSizeValues : []).map((value) => String(value || '').trim())
    );
    let currentSizeMode = sizeModeInput?.value || 'Standaardmaat';
    let photoSelection = null;
    let photoPreviewUrl = '';
    let sizeOptionsExpanded = false;
    let sizeSelectionWasManual = false;
    let sizeStepView = 'list';
    let isSubmittingUpsellSelection = false;
    const selectedUpsellVariantIds = new Set();

    const syncPhotoFitInputs = (currentSizeValue = '') => {
      const parsedSize = parseSizeValue(currentSizeValue);
      const cropRiskMeta =
        photoSelection && parsedSize
          ? getCropRiskMeta(photoSelection.aspectRatio, parsedSize.aspectRatio)
          : null;

      if (selectedSizeRatioInput) {
        selectedSizeRatioInput.value = parsedSize?.aspectRatio ? parsedSize.aspectRatio.toFixed(4) : '';
      }
      if (cropRiskLevelInput) {
        cropRiskLevelInput.value = cropRiskMeta?.level || '';
      }
      if (cropRiskPercentInput) {
        cropRiskPercentInput.value =
          cropRiskMeta && Number.isFinite(cropRiskMeta.percent) ? String(cropRiskMeta.percent) : '';
      }
    };

    const setSizeMode = (mode) => {
      currentSizeMode = mode === 'Eigen afmeting' ? 'Eigen afmeting' : 'Standaardmaat';
      if (sizeModeInput) sizeModeInput.value = currentSizeMode;
    };

    const isStandardSizeValue = (sizeValue) => standardSizeValueSet.has(String(sizeValue || '').trim());

    const getCustomSizeValue = () => {
      const width = String(customSizeWidthInput?.value || '').trim();
      const height = String(customSizeHeightInput?.value || '').trim();
      if (!width || !height) return '';
      return `${width}x${height}cm`;
    };

    const setCustomSizeError = (message = '') => {
      if (!customSizeError) return;
      if (message) {
        customSizeError.hidden = false;
        customSizeError.textContent = message;
      } else {
        customSizeError.hidden = true;
        customSizeError.textContent = '';
      }
    };

    syncSizeLineItemInputs = () => {
      const currentSizeValue =
        (sizeOptionName && selectedOptionsByName[sizeOptionName]) ||
        sizeOptions.find((option) => option.classList.contains('is-selected'))?.dataset.owaSizeValue ||
        '';

      if (selectedSizeInput) {
        selectedSizeInput.value = currentSizeValue;
      }

      if (!currentSizeValue) {
        setSizeMode('Standaardmaat');
      } else if (currentSizeMode !== 'Eigen afmeting' || isStandardSizeValue(currentSizeValue)) {
        setSizeMode(isStandardSizeValue(currentSizeValue) ? 'Standaardmaat' : currentSizeMode);
      }

      syncPhotoFitInputs(currentSizeValue);
    };

    const setPhotoMetadataInputs = (photo) => {
      if (photoRatioInput) photoRatioInput.value = photo?.ratioType || '';
      if (photoRatioBucketInput) photoRatioBucketInput.value = photo?.ratioBucket || '';
      if (photoAspectRatioInput) photoAspectRatioInput.value = photo?.aspectRatio ? photo.aspectRatio.toFixed(4) : '';
      if (photoWidthInput) photoWidthInput.value = photo?.width || '';
      if (photoHeightInput) photoHeightInput.value = photo?.height || '';
      if (photoFileNameInput) photoFileNameInput.value = photo?.fileName || '';
    };

    const syncCustomSizeLeadFields = () => {
      const width = String(customSizeWidthInput?.value || '').trim();
      const height = String(customSizeHeightInput?.value || '').trim();
      const customSizeValue = width && height ? `${width}x${height}cm` : '';
      const selectedPhoto = photoInput?.files?.[0] || null;
      const hasPhoto = !!selectedPhoto;

      if (customSizeRequestedSizeInput) {
        customSizeRequestedSizeInput.value = customSizeValue || '';
      }

      if (customSizePhotoUploadedInput) {
        customSizePhotoUploadedInput.value = hasPhoto ? 'Ja' : 'Nee';
      }

      if (customSizePhotoNameInput) {
        customSizePhotoNameInput.value = selectedPhoto?.name || '';
      }

      if (customSizePhotoDimensionsInput) {
        customSizePhotoDimensionsInput.value =
          photoSelection && Number.isFinite(photoSelection.width) && Number.isFinite(photoSelection.height)
            ? `${photoSelection.width} x ${photoSelection.height} px`
            : '';
      }

      if (customSizePhotoRatioInput) {
        customSizePhotoRatioInput.value = photoSelection
          ? getPhotoRatioLabel(photoSelection.ratioBucket || photoSelection.ratioType)
          : '';
      }

      if (customSizePhotoFileInput) {
        try {
          if (hasPhoto && typeof DataTransfer !== 'undefined') {
            const dt = new DataTransfer();
            Array.from(photoInput.files || []).forEach((file) => dt.items.add(file));
            customSizePhotoFileInput.files = dt.files;
          } else {
            customSizePhotoFileInput.value = '';
          }
        } catch (error) {
          customSizePhotoFileInput.value = '';
          console.warn('OWA PDP custom-size photo attachment sync failed', error);
        }
      }

      if (customSizeContinueBtn) customSizeContinueBtn.disabled = !customSizeValue;
    };

    const setPhotoMessaging = (statusText, metaText = '') => {
      if (photoStatus) photoStatus.textContent = statusText;
      if (photoMeta) {
        if (metaText) {
          photoMeta.hidden = false;
          photoMeta.textContent = metaText;
        } else {
          photoMeta.hidden = true;
          photoMeta.textContent = '';
        }
      }
    };

    const setSizeMatchCopy = (text) => {
      if (sizeMatchSummary) sizeMatchSummary.textContent = text;
      if (photoFilterSummary) photoFilterSummary.textContent = text;
    };

    const openUploadedPhotoLightbox = () => {
      if (!uploadLightbox || !photoPreviewUrl) return;
      if (uploadLightboxImage) {
        uploadLightboxImage.src = photoPreviewUrl;
        uploadLightboxImage.alt =
          photoPreviewImage?.alt ||
          photoCardTitle?.textContent?.trim() ||
          'Preview van je geuploade foto';
      }
      uploadLightbox.classList.add('is-open');
      uploadLightbox.setAttribute('aria-hidden', 'false');
      lockBodyScroll('upload-lightbox');
    };

    const closeUploadedPhotoLightbox = () => {
      if (!uploadLightbox) return;
      uploadLightbox.classList.remove('is-open');
      uploadLightbox.setAttribute('aria-hidden', 'true');
      if (uploadLightboxImage) {
        uploadLightboxImage.removeAttribute('src');
        uploadLightboxImage.alt = '';
      }
      unlockBodyScroll('upload-lightbox');
    };

    const clearPhotoPreview = () => {
      closeUploadedPhotoLightbox();

      if (photoPreviewUrl) {
        URL.revokeObjectURL(photoPreviewUrl);
        photoPreviewUrl = '';
      }

      [photoPreviewRoot, modalPhotoPreviewRoot].forEach((root) => {
        if (root) root.hidden = true;
      });
      [photoPreviewImage, modalPhotoPreviewImage].forEach((image) => {
        if (!image) return;
        image.removeAttribute('src');
        image.alt = '';
      });
      if (upsellSummaryThumb) upsellSummaryThumb.hidden = true;
      if (upsellSummaryImage) {
        upsellSummaryImage.removeAttribute('src');
        upsellSummaryImage.alt = '';
      }
      if (detailSummaryThumb) detailSummaryThumb.hidden = true;
      if (detailSummaryImage) {
        detailSummaryImage.removeAttribute('src');
        detailSummaryImage.alt = '';
      }
      if (photoPreviewCaption) photoPreviewCaption.textContent = '';
      if (photoPlaceholder) photoPlaceholder.hidden = false;
      if (photoPreviewOpenBtn) photoPreviewOpenBtn.hidden = true;
      if (photoCardTitle) photoCardTitle.textContent = photoCardTitle.dataset.owaDefaultText || '';
      if (photoCardSubtitle) photoCardSubtitle.textContent = photoCardSubtitle.dataset.owaDefaultText || '';
      syncPhotoFitInputs('');
      syncCustomSizeLeadFields();
    };

    const setPhotoPreview = (file, photo) => {
      clearPhotoPreview();
      if (!file) return;

      photoPreviewUrl = URL.createObjectURL(file);
      const previewAlt = `Preview van ${file.name}`;
      const previewCaption = photo
        ? `${photo.width} x ${photo.height} px`
        : file.name;

      [photoPreviewRoot, modalPhotoPreviewRoot].forEach((root) => {
        if (root) root.hidden = false;
      });
      [photoPreviewImage, modalPhotoPreviewImage].forEach((image) => {
        if (!image) return;
        image.src = photoPreviewUrl;
        image.alt = previewAlt;
      });
      if (upsellSummaryThumb) upsellSummaryThumb.hidden = false;
      if (upsellSummaryImage) {
        upsellSummaryImage.src = photoPreviewUrl;
        upsellSummaryImage.alt = previewAlt;
      }
      if (detailSummaryThumb) detailSummaryThumb.hidden = false;
      if (detailSummaryImage) {
        detailSummaryImage.src = photoPreviewUrl;
        detailSummaryImage.alt = previewAlt;
      }
      if (photoPreviewCaption) photoPreviewCaption.textContent = previewCaption;
      if (photoPlaceholder) photoPlaceholder.hidden = true;
      if (photoPreviewOpenBtn) photoPreviewOpenBtn.hidden = false;
      if (photoCardTitle) photoCardTitle.textContent = file.name;
      if (photoCardSubtitle) photoCardSubtitle.textContent = `Gedetecteerd: ${getPhotoRatioLabel(photo.ratioBucket || photo.ratioType)}`;
      syncCustomSizeLeadFields();
    };

    photoPreviewOpenBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openUploadedPhotoLightbox();
    });

    uploadLightboxCloseBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeUploadedPhotoLightbox();
    });

    uploadLightbox?.addEventListener('click', (event) => {
      if (event.target === uploadLightbox) {
        closeUploadedPhotoLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && uploadLightbox?.classList.contains('is-open')) {
        closeUploadedPhotoLightbox();
      }
    });

    const setUpsellError = (message = '') => {
      if (!upsellError) return;
      if (message) {
        upsellError.hidden = false;
        upsellError.textContent = message;
      } else {
        upsellError.hidden = true;
        upsellError.textContent = '';
      }
    };

    const clampUpsellQuantity = (value) => {
      const parsedValue = Number.parseInt(String(value || ''), 10);
      if (!Number.isFinite(parsedValue)) return 1;
      return Math.min(10, Math.max(1, parsedValue));
    };

    const getUpsellQuantityInput = (card) => card?.querySelector('[data-owa-upsell-quantity-input]') || null;

    const getUpsellQuantityValue = (card) => {
      const quantityInput = getUpsellQuantityInput(card);
      return quantityInput ? clampUpsellQuantity(quantityInput.value) : 1;
    };

    const syncUpsellQuantityUi = (card) => {
      if (!card) return;
      const quantityInput = getUpsellQuantityInput(card);
      if (!quantityInput) return;
      const quantityValue = clampUpsellQuantity(quantityInput.value);
      quantityInput.value = String(quantityValue);
      const decreaseBtn = card.querySelector('[data-owa-upsell-quantity-decrease]');
      const increaseBtn = card.querySelector('[data-owa-upsell-quantity-increase]');
      if (decreaseBtn) decreaseBtn.disabled = quantityValue <= 1;
      if (increaseBtn) increaseBtn.disabled = quantityValue >= 10;
    };

    const updateUpsellSelectionUi = () => {
      upsellCards.forEach((card) => {
        const variantId = String(card.dataset.owaUpsellVariantId || '');
        const isSelected = selectedUpsellVariantIds.has(variantId);
        card.classList.toggle('is-selected', isSelected);
        const toggle = card.querySelector('[data-owa-upsell-toggle]');
        if (toggle) toggle.textContent = isSelected ? 'Toegevoegd' : 'Voeg toe';
        syncUpsellQuantityUi(card);
      });
    };

    const getDetailCardByValue = (value) =>
      detailCards.find((card) => String(card.dataset.owaDetailValue || '') === String(value || '')) || null;

    const getDetailCardMeta = (value) => {
      const fallback = getDetailDisplayMeta(value);
      const card = getDetailCardByValue(value);
      return {
        title: card?.dataset.owaDetailTitle || fallback.title || String(value || ''),
        note: card?.dataset.owaDetailNote || fallback.note || '',
        fullLabel: fallback.fullLabel || String(value || ''),
      };
    };

    syncDetailLineItemInput = () => {
      if (!selectedDetailInput || !detailOptionName) return;
      selectedDetailInput.value = selectedOptionsByName[detailOptionName] || '';
    };

    const syncDetailSizeSummary = (value) => {
      if (!detailSizeLabel) return;
      detailSizeLabel.textContent =
        getSizeDisplayMeta(value, { preserveOrientation: currentSizeMode === 'Eigen afmeting' }).label ||
        String(value || '');
    };

    const syncUpsellSizeSummary = (value) => {
      if (upsellSizeLabel) {
        upsellSizeLabel.textContent =
          getSizeDisplayMeta(value, { preserveOrientation: currentSizeMode === 'Eigen afmeting' }).label ||
          String(value || '');
      }

      if (!upsellSizePrice) return;
      const variant = resolveVariant();
      if (variant) {
        upsellSizePrice.hidden = false;
        upsellSizePrice.textContent = formatMoney(Number(variant.price || 0));
      } else {
        upsellSizePrice.hidden = true;
        upsellSizePrice.textContent = '';
      }
    };

    syncUpsellDetailSummary = () => {
      if (!upsellDetailLabel || !detailOptionName) return;
      const detailValue = selectedOptionsByName[detailOptionName] || '';
      if (!detailValue) {
        upsellDetailLabel.textContent = '';
        return;
      }
      const detailMeta = getDetailCardMeta(detailValue);
      upsellDetailLabel.textContent = detailMeta.note
        ? `${detailMeta.title} · ${detailMeta.note}`
        : detailMeta.title;
    };

    syncDetailCardsForContext = () => {
      if (!detailOptionName || !detailCards.length) return;

      const currentDetailValue = selectedOptionsByName[detailOptionName] || '';

      detailCards.forEach((card) => {
        const detailValue = String(card.dataset.owaDetailValue || '');
        const variant = resolveVariant({ [detailOptionName]: detailValue });
        const isSelected = detailValue === currentDetailValue;
        const isAvailable = !!variant?.available;
        const priceEl = card.querySelector('[data-owa-detail-price]');
        const compareEl = card.querySelector('[data-owa-detail-compare]');
        const unavailableEl = card.querySelector('[data-owa-detail-unavailable]');

        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-unavailable', !isAvailable);
        card.disabled = !variant || !variant.available;
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (priceEl) priceEl.textContent = variant ? formatMoney(Number(variant.price || 0)) : '';

        const compareAt = Number(variant?.compare_at_price || 0);
        if (compareEl) {
          if (compareAt && variant && compareAt > Number(variant.price || 0)) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(compareAt);
          } else {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
        }

        if (unavailableEl) unavailableEl.hidden = !!variant?.available;
      });
    };

    const setSizeStepView = (view) => {
      sizeStepView = view === 'upsell' ? 'upsell' : view === 'detail' ? 'detail' : 'list';
      const showDetail = sizeStepView === 'detail' && !!detailStep && detailCards.length > 0;
      const showUpsell = sizeStepView === 'upsell' && !!upsellStep && upsellCards.length > 0;

      if (sizeTabsWrap) sizeTabsWrap.hidden = showDetail || showUpsell;
      if (photoFilterSummary) {
        const matchCopy = photoFilterSummary.closest('.owa-pdp__size-modal-match-copy');
        if (matchCopy) matchCopy.hidden = false;
      }
      if (sizeListPanel) sizeListPanel.style.display = showDetail || showUpsell ? 'none' : '';
      if (sizeCustomPanel) sizeCustomPanel.style.display = showDetail || showUpsell ? 'none' : 'none';
      if (sizeMoreToggle && (showDetail || showUpsell)) {
        sizeMoreToggle.hidden = true;
        sizeMoreToggle.setAttribute('aria-expanded', 'false');
      }
      if (detailStep) detailStep.hidden = !showDetail;
      if (upsellStep) upsellStep.hidden = !showUpsell;
      if (!showDetail && !showUpsell) {
        const activeTab = sizeTabs.find((tab) => tab.classList.contains('is-active'))?.dataset.owaSizeTab || 'list';
        if (sizeListPanel) sizeListPanel.style.display = activeTab === 'list' ? '' : 'none';
        if (sizeCustomPanel) sizeCustomPanel.style.display = activeTab === 'custom' ? '' : 'none';
      }
    };

    const openDetailStep = (sizeValue) => {
      if (!detailStep || !detailCards.length) return false;
      syncDetailSizeSummary(sizeValue);
      syncDetailCardsForContext();
      setSizeStepView('detail');
      return true;
    };

    const openUpsellStep = (sizeValue) => {
      if (!upsellStep || !upsellCards.length) return false;
      syncUpsellSizeSummary(sizeValue);
      syncUpsellDetailSummary();
      updateUpsellSelectionUi();
      setUpsellError('');
      setSizeStepView('upsell');
      return true;
    };

    const openDetailInfoModal = () => {
      if (!detailInfoModal) return;
      detailInfoModal.classList.add('is-open');
      detailInfoModal.setAttribute('aria-hidden', 'false');
    };

    const closeDetailInfoModal = () => {
      if (!detailInfoModal) return;
      detailInfoModal.classList.remove('is-open');
      detailInfoModal.setAttribute('aria-hidden', 'true');
    };

    const addMainProductFromForm = async () => {
      if (!productForm) throw new Error('We konden het productformulier niet vinden.');
      if (typeof productForm.reportValidity === 'function' && !productForm.reportValidity()) {
        throw new Error('Controleer eerst of alle verplichte velden zijn ingevuld.');
      }

      const formData = new FormData(productForm);
      const resolvedVariant = resolveVariant();
      if (resolvedVariant?.id) {
        formData.set('id', String(resolvedVariant.id));
      }
      if (sizeOptionName && selectedOptionsByName[sizeOptionName]) {
        formData.set('properties[Gekozen maat]', selectedOptionsByName[sizeOptionName]);
      }
      if (detailOptionName && selectedOptionsByName[detailOptionName]) {
        formData.set('properties[Detailniveau]', selectedOptionsByName[detailOptionName]);
      }
      if (
        photoInput?.files?.[0] &&
        !formData.get('properties[Bekijk de door u geüploade foto]') &&
        !formData.get('properties[Bekijk foto hier]') &&
        !formData.get('properties[Foto upload]')
      ) {
        formData.append('properties[Bekijk de door u geüploade foto]', photoInput.files[0], photoInput.files[0].name);
      }

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const payload = await response.json();
      if (!response.ok || payload?.status) {
        throw new Error(payload?.description || payload?.message || 'Het hoofdproduct kon niet aan de winkelwagen worden toegevoegd.');
      }
      return payload;
    };

    const addSelectedUpsells = async () => {
      const items = upsellCards
        .filter((card) => selectedUpsellVariantIds.has(String(card.dataset.owaUpsellVariantId || '')))
        .map((card) => ({
          id: Number(card.dataset.owaUpsellVariantId),
          quantity: getUpsellQuantityValue(card),
          properties: {
            _upsell_via: productRoot?.dataset?.owaSectionId || 'owa-pdp',
            _upsell_parent_product: productTitleText,
            _upsell_parent_size: selectedOptionsByName[sizeOptionName] || '',
            _upsell_parent_detail: detailOptionName ? selectedOptionsByName[detailOptionName] || '' : '',
          },
        }))
        .filter((item) => Number.isFinite(item.id) && item.id > 0);

      if (!items.length) return null;

      const response = await fetch(cartJsonAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });
      const payload = await response.json();
      if (!response.ok || payload?.status) {
        throw new Error(payload?.description || payload?.message || 'De extra producten konden niet aan de winkelwagen worden toegevoegd.');
      }
      return payload;
    };

    const finishUpsellFlow = async (redirectUrl) => {
      if (isSubmittingUpsellSelection) return;
      isSubmittingUpsellSelection = true;
      if (upsellSubmitBtn) upsellSubmitBtn.disabled = true;
      if (upsellAddAnotherBtn) upsellAddAnotherBtn.disabled = true;
      setUpsellError('');

      try {
        await addMainProductFromForm();
        await addSelectedUpsells();
        window.location = redirectUrl;
      } catch (error) {
        console.error('OWA PDP upsell add failed', error);
        setUpsellError(error?.message || 'Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het opnieuw.');
      } finally {
        isSubmittingUpsellSelection = false;
        if (upsellSubmitBtn) upsellSubmitBtn.disabled = false;
        if (upsellAddAnotherBtn) upsellAddAnotherBtn.disabled = false;
      }
    };

    const syncSizeOptionPresentation = () => {
      sizeOptions.forEach((option) => {
        const labelNode = option.querySelector('[data-owa-size-option-label]');
        const descriptionNode = option.querySelector('[data-owa-size-option-desc]');
        const displayMeta = getSizeDisplayMeta(option.dataset.owaSizeValue);
        if (labelNode) labelNode.textContent = displayMeta.label;
        if (descriptionNode) descriptionNode.textContent = displayMeta.description;
      });
    };

    const syncCustomSizeSelectorsFromCurrentSize = () => {
      if (!customSizePanel || !customSizeWidthInput || !customSizeHeightInput || !sizeOptionName) return;
      if (currentSizeMode !== 'Eigen afmeting') return;
      const currentSizeValue = selectedOptionsByName[sizeOptionName] || '';
      const parsedSize = parseSizeValue(currentSizeValue);
      if (!parsedSize || parsedSize.width < 50 || parsedSize.width > 140 || parsedSize.height < 50 || parsedSize.height > 280) {
        return;
      }
      customSizeWidthInput.value = String(parsedSize.width);
      customSizeHeightInput.value = String(parsedSize.height);
      syncCustomSizeLeadFields();
    };

    const syncCustomSizeSelectionState = () => {
      syncCustomSizeLeadFields();
      if (!customSizePanel) return;
      if (!getCustomSizeValue()) {
        setCustomSizeError('');
      }
    };

    const setSizeOptionVisibility = (option, visible) => {
      option.hidden = !visible;
      option.classList.toggle('is-hidden-by-photo', !visible);
      option.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const syncRecommendedSizeUi = (recommendedOption) => {
      sizeOptions.forEach((option) => {
        const badge = option.querySelector('[data-owa-size-option-badge]');
        const isRecommended = !!recommendedOption && option === recommendedOption;
        option.classList.toggle('is-recommended', isRecommended);
        if (badge) badge.hidden = !isRecommended;
      });
    };

    const syncSizeMoreToggle = (visibleCount, totalMatchingCount) => {
      if (!sizeMoreToggle) return;
      if (sizeStepView === 'upsell') {
        sizeMoreToggle.hidden = true;
        sizeMoreToggle.setAttribute('aria-expanded', 'false');
        return;
      }

      const hasMoreMatchingOptions = totalMatchingCount > visibleCount;
      sizeMoreToggle.hidden = !hasMoreMatchingOptions;
      sizeMoreToggle.setAttribute('aria-expanded', sizeOptionsExpanded ? 'true' : 'false');
    };

    const syncSizeOptionsForPhoto = async () => {
      if (!sizeOptions.length) return;

      if (!photoUploadEnabled) {
        syncRecommendedSizeUi(null);
        sizeOptions.forEach((option) => setSizeOptionVisibility(option, true));
        syncSizeMoreToggle(sizeOptions.length, sizeOptions.length);
        syncSizeLineItemInputs();
        return;
      }

      if (!photoSelection) {
        syncRecommendedSizeUi(null);
        sizeOptions.forEach((option) => setSizeOptionVisibility(option, false));
        setSizeMatchCopy(photoEmptyPrompt);
        sizeOptionsExpanded = false;
        syncSizeMoreToggle(0, 0);
        return;
      }

      const parsedOptions = sizeOptions.map((option, index) => ({
        option,
        index,
        meta: parseSizeValue(option.dataset.owaSizeValue),
        fitMeta: null,
      }));

      parsedOptions.forEach((entry) => {
        if (entry.meta && photoSelection) {
          entry.fitMeta = getCropRiskMeta(photoSelection.aspectRatio, entry.meta.aspectRatio);
        }
      });

      let usedFallbackFamily = false;
      const unconventionalPhoto = isUnconventionalRatioBucket(photoSelection.ratioBucket);
      let visibleEntries = parsedOptions.filter((entry) => {
        if (!entry.meta) return true;
        return entry.meta.ratioType === photoSelection.ratioType;
      });

      if (!visibleEntries.length) {
        usedFallbackFamily = true;
        visibleEntries = parsedOptions.filter((entry) => {
          if (!entry.meta) return true;
          if (photoSelection.ratioType === 'square') return entry.meta.isSquare;
          return !entry.meta.isSquare;
        });
      }

      if (!visibleEntries.length) {
        usedFallbackFamily = true;
        visibleEntries = parsedOptions;
      }

      const preferredSizeSpec = getPreferredSizeSpec(photoSelection);
      const preferredEntry = preferredSizeSpec
        ? visibleEntries.find((entry) => {
            if (!entry.meta) return false;
            return entry.meta.width === preferredSizeSpec.width && entry.meta.height === preferredSizeSpec.height;
          }) || null
        : null;

      visibleEntries.sort((left, right) => {
        if (preferredEntry) {
          if (left.option === preferredEntry.option) return -1;
          if (right.option === preferredEntry.option) return 1;
        }

        const leftArea = left.meta ? left.meta.width * left.meta.height : Number.POSITIVE_INFINITY;
        const rightArea = right.meta ? right.meta.width * right.meta.height : Number.POSITIVE_INFINITY;
        const leftDiff = left.fitMeta?.score ?? Number.POSITIVE_INFINITY;
        const rightDiff = right.fitMeta?.score ?? Number.POSITIVE_INFINITY;

        if (unconventionalPhoto) {
          if (leftDiff !== rightDiff) return leftDiff - rightDiff;
          if (leftArea !== rightArea) return rightArea - leftArea;
          return left.index - right.index;
        }

        if (leftArea !== rightArea) return leftArea - rightArea;
        if (leftDiff !== rightDiff) return leftDiff - rightDiff;
        return left.index - right.index;
      });

      const currentSelectedSize = sizeOptionName ? selectedOptionsByName[sizeOptionName] : '';
      let visibleEntriesToRender = sizeOptionsExpanded
        ? visibleEntries
        : visibleEntries.slice(0, sizeVisibleLimit);
      const currentSelectedEntry = visibleEntries.find(
        (entry) => entry.option.dataset.owaSizeValue === currentSelectedSize
      );
      if (
        !sizeOptionsExpanded &&
        currentSelectedEntry &&
        !visibleEntriesToRender.some((entry) => entry.option === currentSelectedEntry.option)
      ) {
        visibleEntriesToRender = [
          ...visibleEntriesToRender.slice(0, Math.max(sizeVisibleLimit - 1, 0)),
          currentSelectedEntry,
        ];
      }

      const visibleOptions = new Set(visibleEntriesToRender.map((entry) => entry.option));
      const hiddenEntries = parsedOptions.filter((entry) => !visibleOptions.has(entry.option));

      visibleEntriesToRender.forEach((entry) => setSizeOptionVisibility(entry.option, true));
      hiddenEntries.forEach((entry) => setSizeOptionVisibility(entry.option, false));
      syncSizeMoreToggle(visibleEntriesToRender.length, visibleEntries.length);

      if (sizeList) {
        [...visibleEntriesToRender, ...hiddenEntries].forEach((entry) => {
          sizeList.appendChild(entry.option);
        });
      }

      syncRecommendedSizeUi(preferredEntry?.option || null);

      parsedOptions.forEach((entry) => {
        const descriptionNode = entry.option.querySelector('[data-owa-size-option-desc]');
        if (!descriptionNode) return;
        const displayMeta = getSizeDisplayMeta(entry.option.dataset.owaSizeValue);
        const fitLabel = entry.fitMeta?.label || '';
        descriptionNode.textContent = fitLabel
          ? `${displayMeta.description} · ${fitLabel}`
          : displayMeta.description;
      });

      const familyCopyByType = {
        square: 'vierkante maten',
        landscape: 'liggende maten',
        portrait: 'staande maten',
      };
      const familyCopy = familyCopyByType[photoSelection.ratioType] || 'passende maten';
      const bestVisibleFit = visibleEntries[0]?.fitMeta || null;
      const photoLabel = getPhotoRatioLabel(photoSelection.ratioBucket || photoSelection.ratioType);
      if (unconventionalPhoto) {
        if (bestVisibleFit?.level === 'hoog') {
          setSizeMatchCopy(
            `Je foto is een ${photoLabel}. We tonen eerst de minst risicovolle standaardmaten. Wil je zoveel mogelijk van je volledige beeld behouden, dan kun je daarna nog steeds 'Eigen afmeting' kiezen.`
          );
        } else if (bestVisibleFit?.level === 'hoog' || bestVisibleFit?.level === 'middel') {
          setSizeMatchCopy(
            `Je foto is een ${photoLabel}. We hebben je volledige foto ontvangen. We tonen eerst de minst risicovolle standaardmaten; andere maten kunnen uitsnede vragen. Voor meer behoud van beeld kun je ook 'Eigen afmeting' kiezen.`
          );
        } else {
          setSizeMatchCopy(
            `Je foto is een ${photoLabel}. We tonen eerst de best passende ${familyCopy}, gesorteerd op zo min mogelijk uitsnede.`
          );
        }
      } else if (usedFallbackFamily && photoSelection.ratioType !== 'square') {
        setSizeMatchCopy(
          `We hebben nog geen aparte ${familyCopy} als standaardvariant, dus we tonen de dichtstbijzijnde rechthoekige maten van klein naar groot voor jouw ${photoLabel}.`
        );
      } else {
        setSizeMatchCopy(
          `We tonen ${familyCopy} van klein naar groot, passend bij jouw ${photoLabel}.`
        );
      }

      sizeOptions.forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.owaSizeValue === currentSelectedSize);
      });
      const currentSelectionVisible = visibleEntriesToRender.some(
        (entry) => entry.option.dataset.owaSizeValue === currentSelectedSize
      );
      const shouldPreferRecommendedSize =
        !!preferredEntry &&
        currentSizeMode !== 'Eigen afmeting' &&
        !sizeSelectionWasManual &&
        currentSelectedSize !== preferredEntry.option.dataset.owaSizeValue;

      if (currentSizeMode === 'Eigen afmeting') {
        syncSizeLineItemInputs();
      } else if ((shouldPreferRecommendedSize || !currentSelectionVisible) && visibleEntries.length > 0) {
        const nextPreferredOption = shouldPreferRecommendedSize
          ? preferredEntry.option
          : visibleEntries[0].option;
        const nextPreferredValue = nextPreferredOption.dataset.owaSizeValue;
        if (nextPreferredValue && sizeOptionName) {
          sizeOptions.forEach((option) => option.classList.remove('is-selected'));
          setSizeMode('Standaardmaat');
          setFormattedSizeLabel(sizeCardName, nextPreferredValue);
          await applyOptionSelection(sizeOptionName, nextPreferredValue, nextPreferredOption);
          nextPreferredOption.classList.add('is-selected');
        }
      } else {
        syncSizeLineItemInputs();
      }
    };

    const openSizeModal = () => {
      if (!sizeModal) return;
      sizeOptionsExpanded = false;
      setSizeStepView('list');
      sizeModal.classList.add('is-open');
      sizeModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll('size-modal');
      if (currentSizeMode === 'Eigen afmeting') {
        syncCustomSizeSelectorsFromCurrentSize();
      }
      syncSizeOptionsForPhoto().catch((error) => {
        console.warn('OWA PDP size modal sync failed', error);
      }).finally(() => {
        setActiveSizeTab('list');
      });
    };

    const closeSizeModal = () => {
      if (!sizeModal) return;
      setSizeStepView('list');
      setUpsellError('');
      closeDetailInfoModal();
      sizeModal.classList.remove('is-open');
      sizeModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('size-modal');
    };

    sizeOpenBtns.forEach(btn => btn.addEventListener('click', openSizeModal));
    sizeCloseBtns.forEach((btn) => btn.addEventListener('click', closeSizeModal));
    sizeModal?.addEventListener('click', (e) => { if (e.target === sizeModal) closeSizeModal(); });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (detailInfoModal?.classList.contains('is-open')) {
        closeDetailInfoModal();
        return;
      }
      if (sizeModal?.classList.contains('is-open')) closeSizeModal();
    });

    /* Tab switching */
    const sizeTabs = [...(sizeModal?.querySelectorAll('[data-owa-size-tab]') || [])];
    const sizeListPanel = sizeModal?.querySelector('[data-owa-size-panel="list"]');
    const sizeCustomPanel = sizeModal?.querySelector('[data-owa-size-panel="custom"]');

    function setActiveSizeTab(panel) {
      const nextPanel = panel === 'custom' && sizeCustomPanel ? 'custom' : 'list';
      const targetTab =
        sizeTabs.find((tab) => tab.dataset.owaSizeTab === nextPanel) || sizeTabs[0] || null;

      setSizeStepView('list');
      sizeTabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === targetTab);
      });

      if (sizeListPanel) sizeListPanel.style.display = nextPanel === 'list' ? '' : 'none';
      if (sizeCustomPanel) sizeCustomPanel.style.display = nextPanel === 'custom' ? '' : 'none';
      if (nextPanel === 'custom') {
        syncCustomSizeSelectorsFromCurrentSize();
        syncCustomSizeSelectionState();
      }
    }

    sizeTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        setActiveSizeTab(tab.dataset.owaSizeTab || 'list');
      });
    });

    customSizeWidthInput?.addEventListener('input', syncCustomSizeSelectionState);
    customSizeWidthInput?.addEventListener('change', syncCustomSizeSelectionState);
    customSizeHeightInput?.addEventListener('input', syncCustomSizeSelectionState);
    customSizeHeightInput?.addEventListener('change', syncCustomSizeSelectionState);
    customSizeLeadForm?.addEventListener('submit', (event) => {
      syncCustomSizeLeadFields();

      if (photoUploadEnabled && photoUploadRequired && !photoInput?.files?.[0]) {
        event.preventDefault();
        openSizeModal();
      }
    });

    customSizeContinueBtn?.addEventListener('click', async () => {
      setCustomSizeError('');

      if (photoUploadEnabled && photoUploadRequired && !photoInput?.files?.[0]) {
        setCustomSizeError('Upload eerst je foto voordat je een eigen afmeting kiest.');
        return;
      }

      const sizeValue = getCustomSizeValue();
      if (!sizeValue) {
        setCustomSizeError('Kies eerst je breedte en hoogte.');
        return;
      }

      const previewVariant = sizeOptionName ? resolveVariant({ [sizeOptionName]: sizeValue }) : null;
      if (!previewVariant) {
        setCustomSizeError('Deze afmeting is nog niet beschikbaar. Kies een andere combinatie.');
        return;
      }

      sizeSelectionWasManual = true;
      setSizeMode('Eigen afmeting');
      setFormattedSizeLabel(sizeCardName, sizeValue, { preserveOrientation: true });
      if (sizeOptionName) await applyOptionSelection(sizeOptionName, sizeValue, null);
      syncCustomSizeSelectionState();
      if (openDetailStep(sizeValue)) return;
      if (openUpsellStep(sizeValue)) return;
      closeSizeModal();
    });

    if (
      customSizeLeadSubmitBtn?.dataset.owaCustomSizePosted === 'true' ||
      customSizeLeadSubmitBtn?.dataset.owaCustomSizeHasErrors === 'true'
    ) {
      requestAnimationFrame(() => {
        openSizeModal();
      });
    }

    /* Size option click handler */
    sizeOptions.forEach(opt => {
      opt.addEventListener('click', async () => {
        const value = opt.dataset.owaSizeValue;
        sizeSelectionWasManual = true;
        setSizeMode('Standaardmaat');
        setCustomSizeError('');

        /* Update selected state in modal */
        sizeOptions.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        /* Update compact card */
        setFormattedSizeLabel(sizeCardName, value);

        if (sizeOptionName) await applyOptionSelection(sizeOptionName, value, opt);
        if (openDetailStep(value)) return;
        if (openUpsellStep(value)) return;
        closeSizeModal();
      });
    });

    sizeMoreToggle?.addEventListener('click', () => {
      sizeOptionsExpanded = true;
      syncSizeOptionsForPhoto().catch((error) => {
        console.warn('OWA PDP size modal expand failed', error);
      });
    });

    detailCards.forEach((card) => {
      card.addEventListener('click', async () => {
        if (!detailOptionName || card.disabled) return;
        const value = String(card.dataset.owaDetailValue || '');
        if (!value) return;
        await applyOptionSelection(detailOptionName, value, card);
        const currentSizeValue = sizeOptionName ? selectedOptionsByName[sizeOptionName] || '' : '';
        if (openUpsellStep(currentSizeValue)) return;
        closeSizeModal();
      });
    });

    detailBackBtn?.addEventListener('click', () => {
      setSizeStepView('list');
      syncSizeOptionsForPhoto().catch((error) => {
        console.warn('OWA PDP detail back-to-size sync failed', error);
      });
    });

    detailInfoOpenBtn?.addEventListener('click', () => {
      openDetailInfoModal();
    });

    detailInfoCloseBtns.forEach((button) => {
      button.addEventListener('click', () => {
        closeDetailInfoModal();
      });
    });

    detailInfoModal?.addEventListener('click', (event) => {
      if (event.target === detailInfoModal) closeDetailInfoModal();
    });

    upsellToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const card = toggle.closest('[data-owa-upsell-card]');
        const variantId = String(card?.dataset.owaUpsellVariantId || '');
        if (!variantId) return;
        if (selectedUpsellVariantIds.has(variantId)) {
          selectedUpsellVariantIds.delete(variantId);
        } else {
          selectedUpsellVariantIds.add(variantId);
        }
        setUpsellError('');
        updateUpsellSelectionUi();
      });
    });

    upsellCards.forEach((card) => {
      const quantityInput = getUpsellQuantityInput(card);
      if (!quantityInput) return;
      if (card.dataset.owaUpsellQuantityInitialized === 'true') return;
      card.dataset.owaUpsellQuantityInitialized = 'true';

      const decreaseBtn = card.querySelector('[data-owa-upsell-quantity-decrease]');
      const increaseBtn = card.querySelector('[data-owa-upsell-quantity-increase]');

      decreaseBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        quantityInput.value = String(clampUpsellQuantity(Number(quantityInput.value) - 1));
        syncUpsellQuantityUi(card);
      });

      increaseBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        quantityInput.value = String(clampUpsellQuantity(Number(quantityInput.value) + 1));
        syncUpsellQuantityUi(card);
      });

      quantityInput.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      quantityInput.addEventListener('input', () => {
        syncUpsellQuantityUi(card);
      });

      quantityInput.addEventListener('blur', () => {
        syncUpsellQuantityUi(card);
      });
    });

    upsellBackBtn?.addEventListener('click', () => {
      const currentSizeValue = sizeOptionName ? selectedOptionsByName[sizeOptionName] || '' : '';
      if (openDetailStep(currentSizeValue)) return;
      setSizeStepView('list');
      syncSizeOptionsForPhoto().catch((error) => {
        console.warn('OWA PDP upsell back-to-size sync failed', error);
      });
    });

    upsellSubmitBtn?.addEventListener('click', async () => {
      await finishUpsellFlow(cartUrl);
    });

    upsellAddAnotherBtn?.addEventListener('click', async () => {
      await finishUpsellFlow(addAnotherPhotoUrl);
    });

    /* Initialize size from active swatch */
    const sizeOption = optionGroups.find((group) => {
      if (!group) return false;
      if (sizeOptionName && group.dataset.owaOptionName === sizeOptionName) return true;
      return Number(group.dataset.optionIndex || -1) === sizeOptionIndex;
    });
    const sizeValues = sizeOption
      ? [...sizeOption.querySelectorAll('.owa-pdp__swatch')].map((s) => s.dataset.optionValue)
      : sizeOptions.map((option) => option.dataset.owaSizeValue).filter(Boolean);

    if (sizeValues.length > 0 && sizeCardName) {
      const activeSwatch = sizeOption?.querySelector('.owa-pdp__swatch.is-active');
      const activeModalOption = sizeOptions.find((option) => option.classList.contains('is-selected'));
      const initialSize =
        (sizeOptionName && selectedOptionsByName[sizeOptionName]) ||
        (activeSwatch ? activeSwatch.dataset.optionValue : activeModalOption?.dataset.owaSizeValue || sizeValues[0]);
      if (sizeOptionName) selectedOptionsByName[sizeOptionName] = initialSize;
      setSizeMode(isStandardSizeValue(initialSize) ? 'Standaardmaat' : 'Eigen afmeting');
      setFormattedSizeLabel(sizeCardName, initialSize, {
        preserveOrientation: !isStandardSizeValue(initialSize),
      });
      if (sizeOptionName && !shouldUseHighVariantRefresh) {
        applyOptionSelection(sizeOptionName, initialSize, activeSwatch || activeModalOption || null);
      }
    }
    syncSizeOptionPresentation();
    syncSizeLineItemInputs();
    syncDetailLineItemInput();
    syncDetailCardsForContext();
    syncUpsellDetailSummary();
    syncCustomSizeLeadFields();
    syncCustomSizeSelectorsFromCurrentSize();

    if (photoUploadEnabled && photoInput) {
      const handlePhotoSelection = async () => {
        const selectedFile = photoInput.files?.[0];

        if (!selectedFile) {
          photoSelection = null;
          sizeOptionsExpanded = false;
          sizeSelectionWasManual = false;
          setPhotoMetadataInputs(null);
          setPhotoMessaging(photoEmptyPrompt);
          clearPhotoPreview();
          await syncSizeOptionsForPhoto();
          return;
        }

        try {
          const dimensions = await readImageDimensions(selectedFile);
          sizeOptionsExpanded = false;
          sizeSelectionWasManual = false;
          photoSelection = {
            fileName: selectedFile.name,
            width: dimensions.width,
            height: dimensions.height,
            ratioType: getPhotoRatioType(dimensions.width, dimensions.height),
            ratioBucket: getPhotoRatioBucket(dimensions.width, dimensions.height),
            aspectRatio: dimensions.width / dimensions.height,
            normalizedRatio: Math.max(dimensions.width, dimensions.height) / Math.min(dimensions.width, dimensions.height),
          };

          setPhotoMetadataInputs(photoSelection);
          setPhotoPreview(selectedFile, photoSelection);
          setPhotoMessaging(
            `Bestand geselecteerd: ${selectedFile.name}`,
            `Gedetecteerd: ${getPhotoRatioLabel(photoSelection.ratioBucket || photoSelection.ratioType)} · ${photoSelection.width} x ${photoSelection.height} px`
          );

          await syncSizeOptionsForPhoto();
          syncCustomSizeLeadFields();
        } catch (error) {
          console.warn('OWA PDP photo upload parsing failed', error);
          photoSelection = null;
          setPhotoMetadataInputs(null);
          clearPhotoPreview();
          setPhotoMessaging('We konden de afmetingen van je foto niet lezen. Kies een ander bestand.');
          await syncSizeOptionsForPhoto();
          syncCustomSizeLeadFields();
        }
      };

      photoInput.addEventListener('change', () => {
        handlePhotoSelection().catch((error) => {
          console.warn('OWA PDP photo upload sync failed', error);
        });
      });

      setPhotoMessaging(photoEmptyPrompt);
      syncSizeOptionsForPhoto().catch((error) => {
        console.warn('OWA PDP initial photo size sync failed', error);
      });
    }

    /* ── Inline list picker (no modal) ── */
    const listInline = sectionRoot.querySelector('[data-owa-list-inline]');
    const listSegmentButtons = [...(listInline?.querySelectorAll('[data-owa-list-segment]') || [])];
    const listColorWrap = sectionRoot.querySelector('[data-owa-list-color-wrap]');
    const listColorButtons = [...(listColorWrap?.querySelectorAll('[data-owa-list-color-button]') || [])];
    const listOptionName = listInline?.dataset.owaListOptionName || '';
    const listWithoutValues = (listInline?.dataset.owaListWithoutValues || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
    const listWithValues = (listInline?.dataset.owaListWithValues || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
    const listWithoutDefault = listInline?.dataset.owaListWithoutDefault || '';
    const listWithDefault = listInline?.dataset.owaListWithDefault || '';
    const listFrameColorInput = container.querySelector('[data-owa-frame-color-input]');
    const listFramePriceInput = container.querySelector('[data-owa-frame-price-input]');
    const hasInlineListController = !!listInline && !!listOptionName;
    let lastWithListValue = '';

    const normalizeListToken = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
    const listWithoutValueSet = new Set(listWithoutValues.map(normalizeListToken).filter(Boolean));
    const listWithValueSet = new Set(listWithValues.map(normalizeListToken).filter(Boolean));

    const isWithoutListValue = (value) => listWithoutValueSet.has(normalizeListToken(value));
    const isWithTriggerValue = (value) => listWithValueSet.has(normalizeListToken(value));
    const getListSelectionState = (value) => {
      if (!value || isWithoutListValue(value)) return 'without';
      if (isWithTriggerValue(value)) return 'with-trigger';
      return 'direct-color';
    };
    const getListColorButtonByValue = (value) =>
      listColorButtons.find((button) => getButtonOptionValue(button) === value) || null;

    const syncListDerivedInputs = (selectedValue) => {
      if (!listFrameColorInput && !listFramePriceInput) return;

      const selectedButton = getListColorButtonByValue(selectedValue);
      if (getListSelectionState(selectedValue) !== 'direct-color' || !selectedButton) {
        if (listFrameColorInput) listFrameColorInput.value = '';
        if (listFramePriceInput) listFramePriceInput.value = '';
        return;
      }

      if (listFrameColorInput) {
        listFrameColorInput.value = selectedButton.dataset.frameColorValue || getButtonOptionValue(selectedButton);
      }
      if (listFramePriceInput) {
        listFramePriceInput.value = selectedButton.dataset.frameColorPrice || '';
      }
    };

    const resolveDefaultWithValue = () => {
      const firstSpecificWithValue = listColorButtons
        .map((button) => getButtonOptionValue(button))
        .find((value) => value && !isWithoutListValue(value) && !isWithTriggerValue(value));
      if (firstSpecificWithValue) return firstSpecificWithValue;

      const firstGenericWithValue = listColorButtons
        .map((button) => getButtonOptionValue(button))
        .find((value) => value && !isWithoutListValue(value));
      if (firstGenericWithValue) return firstGenericWithValue;

      return (
        listWithDefault ||
        listSegmentButtons.find((button) => button.dataset.owaListSegment === 'with')?.dataset.owaListSegmentValue ||
        ''
      );
    };

    syncListInlineState = () => {
      if (!listInline || !listOptionName) return;

      const selectedValue = selectedOptionsByName[listOptionName] || '';
      const selectionState = getListSelectionState(selectedValue);
      const withoutSelected = selectionState === 'without';
      const activeColorValue = selectionState === 'direct-color' ? selectedValue : '';

      if (activeColorValue) lastWithListValue = activeColorValue;

      listSegmentButtons.forEach((button) => {
        const segment = button.dataset.owaListSegment;
        button.classList.toggle('is-active', segment === (withoutSelected ? 'without' : 'with'));
      });

      listColorButtons.forEach((button) => {
        const value = getButtonOptionValue(button);
        const isSelected = !!activeColorValue && value === activeColorValue;
        button.classList.toggle('is-selected', isSelected);
        button.classList.toggle('is-active', isSelected);
      });

      if (listColorWrap) {
        listColorWrap.classList.toggle('is-disabled', withoutSelected);
        listColorWrap.hidden = withoutSelected;
        listColorWrap.setAttribute('aria-hidden', withoutSelected ? 'true' : 'false');
      }

      syncListDerivedInputs(selectedValue);
    };

    listSegmentButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        if (!listOptionName) return;

        const segment = button.dataset.owaListSegment;
        let targetValue = '';

        if (segment === 'without') {
          targetValue = button.dataset.owaListSegmentValue || listWithoutDefault || listWithoutValues[0] || '';
        } else {
          targetValue =
            lastWithListValue ||
            resolveDefaultWithValue() ||
            button.dataset.owaListSegmentValue ||
            '';
        }

        if (!targetValue) return;

        const sourceButton =
          listColorButtons.find((node) => getButtonOptionValue(node) === targetValue) ||
          listSegmentButtons.find((node) => (node.dataset.owaListSegmentValue || '') === targetValue) ||
          null;
        await applyOptionSelection(listOptionName, targetValue, sourceButton);
        if (!shouldUseHighVariantRefresh) syncListInlineState();
      });
    });

    syncListInlineState();

    /* ── Tips Modal (Maat keuzehulp) ── */
    const tipsModal = queryInSectionOrDocument('[data-owa-size-tips-modal]');
    const tipsOpenBtns = [...sectionRoot.querySelectorAll('[data-owa-size-tips-open]')];
    const tipsCloseBtns = [...(tipsModal?.querySelectorAll('[data-owa-size-tips-close]') || [])];

    const openTipsModal = () => {
      if (!tipsModal) return;
      tipsModal.classList.add('is-open');
      tipsModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll('tips-modal');
    };

    const closeTipsModal = () => {
      if (!tipsModal) return;
      tipsModal.classList.remove('is-open');
      tipsModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('tips-modal');
    };

    tipsOpenBtns.forEach(btn => btn.addEventListener('click', openTipsModal));
    tipsCloseBtns.forEach(btn => btn.addEventListener('click', closeTipsModal));
    tipsModal?.addEventListener('click', (e) => { if (e.target === tipsModal) closeTipsModal(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && tipsModal?.classList.contains('is-open')) closeTipsModal();
    });

    /* ── Delivery Modal (Levertijden) ── */
    const deliveryModal = queryInSectionOrDocument('[data-owa-delivery-modal]');
    const deliveryOpenBtns = [...sectionRoot.querySelectorAll('[data-owa-delivery-open]')];
    const deliveryCloseBtns = [...(deliveryModal?.querySelectorAll('[data-owa-delivery-close]') || [])];

    const openDeliveryModal = () => {
      if (!deliveryModal) return;
      deliveryModal.classList.add('is-open');
      deliveryModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll('delivery-modal');
    };

    const closeDeliveryModal = () => {
      if (!deliveryModal) return;
      deliveryModal.classList.remove('is-open');
      deliveryModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('delivery-modal');
    };

    deliveryOpenBtns.forEach(btn => btn.addEventListener('click', openDeliveryModal));
    deliveryCloseBtns.forEach(btn => btn.addEventListener('click', closeDeliveryModal));
    deliveryModal?.addEventListener('click', (e) => { if (e.target === deliveryModal) closeDeliveryModal(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && deliveryModal?.classList.contains('is-open')) closeDeliveryModal();
    });

    /* ── Finish Picker + Modal ── */
    const finishCardName = sectionRoot.querySelector('[data-owa-finish-card-name]');
    const finishOpenBtns = [...sectionRoot.querySelectorAll('[data-owa-finish-open]')];
    const finishModal = queryInSectionOrDocument('[data-owa-finish-modal]');
    const finishCloseBtns = [...(finishModal?.querySelectorAll('[data-owa-finish-close]') || [])];
    const finishOptions = [...(finishModal?.querySelectorAll('[data-owa-finish-value]') || [])];
    const finishInput = container.querySelector('[data-owa-finish-input]');

    const openFinishModal = () => {
      if (!finishModal) return;
      finishModal.classList.add('is-open');
      finishModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll('finish-modal');
    };

    const closeFinishModal = () => {
      if (!finishModal) return;
      finishModal.classList.remove('is-open');
      finishModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll('finish-modal');
    };

    finishOpenBtns.forEach(btn => btn.addEventListener('click', openFinishModal));
    finishCloseBtns.forEach((btn) => btn.addEventListener('click', closeFinishModal));
    finishModal?.addEventListener('click', (e) => { if (e.target === finishModal) closeFinishModal(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && finishModal?.classList.contains('is-open')) closeFinishModal();
    });

    finishOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        const value = opt.dataset.owaFinishValue;

        /* Update selected state */
        finishOptions.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        /* Update compact card */
        if (finishCardName) finishCardName.textContent = value;

        /* Update line item property */
        if (finishInput) finishInput.value = value;

        closeFinishModal();
      });
    });

    /* ── Frame options ── */
    const frameToggle = sectionRoot.querySelector('[data-owa-frame-toggle]');
    const frameInput = container.querySelector('[data-owa-frame-input]');
    const frameColorsPanel = sectionRoot.querySelector('[data-owa-frame-colors]');
    const frameColorInput = container.querySelector('[data-owa-frame-color-input]');
    const framePriceInput = container.querySelector('[data-owa-frame-price-input]');
    const frameColorOptions = frameColorsPanel ? [...frameColorsPanel.querySelectorAll('[data-frame-color-value]')] : [];
    const frameOptionName = (frameColorsPanel?.dataset.owaFrameOptionName || '').trim();
    const frameTriggerValues = (frameColorsPanel?.dataset.owaFrameTriggerValues || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    const normalizeToken = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
    const frameTriggerExactSet = new Set(frameTriggerValues.map((value) => value.toLowerCase()));
    const frameTriggerHandleSet = new Set(frameTriggerValues.map((value) => normalizeToken(value)));
    const frameColorValueExactSet = new Set(
      frameColorOptions
        .map((option) => String(option.dataset.frameColorValue || '').trim().toLowerCase())
        .filter(Boolean)
    );
    const frameColorValueHandleSet = new Set(
      frameColorOptions
        .map((option) => normalizeToken(option.dataset.frameColorValue || ''))
        .filter(Boolean)
    );

    const setFrameColorInputs = (name, price) => {
      if (frameColorInput) frameColorInput.value = name;
      if (framePriceInput) framePriceInput.value = price;
    };
    const useVariantDrivenFrameOptions = !!frameOptionName && frameTriggerValues.length > 0;

    if (hasInlineListController) {
      updateFrameOptionsVisibility = () => {};
    } else if (useVariantDrivenFrameOptions) {
      updateFrameOptionsVisibility = () => {
        if (!frameColorsPanel) {
          setFrameColorInputs('', '');
          if (frameInput) frameInput.value = '';
          return;
        }

        const selectedFrameValue = selectedOptionsByName[frameOptionName];
        const selectedFrameValueNorm = normalizeToken(selectedFrameValue);
        const selectedFrameValueLower = String(selectedFrameValue || '').trim().toLowerCase();
        const hasFrame = !!selectedFrameValue && (
          frameTriggerExactSet.has(selectedFrameValueLower) ||
          frameTriggerHandleSet.has(selectedFrameValueNorm)
        );
        const isDirectFrameColorValue = !!selectedFrameValue && (
          frameColorValueExactSet.has(selectedFrameValueLower) ||
          frameColorValueHandleSet.has(selectedFrameValueNorm)
        );

        if (!hasFrame || isDirectFrameColorValue) {
          frameColorsPanel.style.display = 'none';
          setFrameColorInputs('', '');
          if (frameInput) frameInput.value = '';
          return;
        }

        frameColorsPanel.style.display = '';
        if (frameInput) frameInput.value = selectedFrameValue;

        let selectedColorNode = frameColorsPanel.querySelector('.owa-pdp__frame-color.is-selected');
        if (!selectedColorNode && frameColorOptions.length) {
          selectedColorNode = frameColorOptions[0];
          selectedColorNode.classList.add('is-selected');
        }
        if (selectedColorNode) {
          setFrameColorInputs(selectedColorNode.dataset.frameColorValue, selectedColorNode.dataset.frameColorPrice);
        }
      };
    } else if (frameToggle) {
      const legacyToggleButtons = [...frameToggle.querySelectorAll('.owa-pdp__toggle-btn')];
      const legacyWithValue =
        legacyToggleButtons.find((button) => button.dataset.toggleMode === 'with')?.dataset.toggleValue ||
        legacyToggleButtons[1]?.dataset.toggleValue ||
        '';
      const applyLegacyFrameToggle = () => {
        const activeButton =
          frameToggle.querySelector('.owa-pdp__toggle-btn.is-active') ||
          frameToggle.querySelector('.owa-pdp__toggle-btn');

        if (!activeButton || !frameColorsPanel) return;
        if (frameInput) frameInput.value = activeButton.dataset.toggleValue || '';

        if ((activeButton.dataset.toggleValue || '') === legacyWithValue) {
          frameColorsPanel.style.display = '';
          const selectedNode = frameColorsPanel.querySelector('.owa-pdp__frame-color.is-selected') || frameColorOptions[0];
          if (selectedNode) {
            selectedNode.classList.add('is-selected');
            setFrameColorInputs(selectedNode.dataset.frameColorValue, selectedNode.dataset.frameColorPrice);
          }
        } else {
          frameColorsPanel.style.display = 'none';
          setFrameColorInputs('', '');
        }
      };

      frameToggle.querySelectorAll('.owa-pdp__toggle-btn').forEach((button) => {
        button.addEventListener('click', () => {
          frameToggle.querySelectorAll('.owa-pdp__toggle-btn').forEach((candidate) => candidate.classList.remove('is-active'));
          button.classList.add('is-active');
          applyLegacyFrameToggle();
        });
      });

      applyLegacyFrameToggle();
    } else if (frameColorsPanel) {
      frameColorsPanel.style.display = 'none';
      setFrameColorInputs('', '');
      if (frameInput) frameInput.value = '';
    }

    frameColorOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        frameColorOptions.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        setFrameColorInputs(opt.dataset.frameColorValue, opt.dataset.frameColorPrice);
      });
    });

    /* ── Property pickers (line item properties, non-price-impact) ── */
    const propertyButtons = [...sectionRoot.querySelectorAll('[data-owa-property-name][data-owa-property-value]')];
    const propertyInputs = [...container.querySelectorAll('[data-owa-property-input]')];
    const getPropertyInput = (name) => propertyInputs.find((input) => input.dataset.owaPropertyInput === name);

    propertyButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const propertyName = button.dataset.owaPropertyName;
        const propertyValue = button.dataset.owaPropertyValue;
        const hiddenInput = getPropertyInput(propertyName);
        if (hiddenInput) hiddenInput.value = propertyValue;
        propertyButtons.forEach((candidate) => {
          if (candidate.dataset.owaPropertyName === propertyName) {
            candidate.classList.toggle('is-active', candidate === button);
          }
        });
      });
    });

    propertyInputs.forEach((input) => {
      const propertyName = input.dataset.owaPropertyInput;
      const currentValue = input.value;
      propertyButtons.forEach((candidate) => {
        if (candidate.dataset.owaPropertyName === propertyName) {
          candidate.classList.toggle('is-active', candidate.dataset.owaPropertyValue === currentValue);
        }
      });
    });

    if (!shouldUseHighVariantRefresh) {
      try { setVariantUI(resolveVariant() || variantCatalog[0]); } catch (e) { void e; }
    }
    updateFrameOptionsVisibility();

    /* ── Reviews carousel ── */
    const reviewsRoot = judgeMeReviewsRoot || sectionRoot;
    const reviewsSection =
      reviewsRoot?.matches?.('[data-owa-reviews-component]')
        ? reviewsRoot
        : reviewsRoot?.querySelector('[data-owa-reviews-component]');
    const reviewsTrack = reviewsSection?.querySelector('[data-owa-reviews-track]');
    const reviewsNav = reviewsSection?.querySelector('[data-owa-reviews-nav]');
    const reviewsPrevBtn = reviewsSection?.querySelector('[data-owa-reviews-prev]');
    const reviewsNextBtn = reviewsSection?.querySelector('[data-owa-reviews-next]');
    const reviewsPagination = reviewsSection?.querySelector('[data-owa-reviews-pagination]');
    const reviewsLoadedState = reviewsSection?.querySelector('[data-owa-reviews-loaded-state]');
    const reviewsLoadMoreBtn = reviewsSection?.querySelector('[data-owa-reviews-load-more]');
    const reviewsLightbox = reviewsSection?.querySelector('[data-owa-reviews-lightbox]');
    const reviewsLightboxImage = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-image]');
    const reviewsLightboxCaption = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-caption]');
    const reviewsLightboxCount = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-count]');
    const reviewsLightboxClose = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-close]');
    const reviewsLightboxPrev = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-prev]');
    const reviewsLightboxNext = reviewsLightbox?.querySelector('[data-owa-reviews-lightbox-next]');
    const reviewsEndpoint = reviewsSection?.dataset.owaReviewsEndpoint || '';
    const reviewsShopDomain = reviewsSection?.dataset.owaReviewsShopDomain || '';
    const reviewsProductId = reviewsSection?.dataset.owaReviewsProductId || '';
    const reviewsBatchSize = Math.max(1, Number.parseInt(reviewsSection?.dataset.owaReviewsBatchSize || '20', 10) || 20);
    let totalReviewCount = Math.max(
      Number.parseInt(reviewsSection?.dataset.owaReviewsTotalCount || '0', 10) || 0,
      reviewsTrack ? reviewsTrack.querySelectorAll('[data-owa-review-slide]').length : 0
    );
    let currentJudgeMePage = Math.max(1, Number.parseInt(reviewsSection?.dataset.owaReviewsInitialPage || '1', 10) || 1);
    let currentReviewPage = 0;
    let reviewScrollRaf = 0;
    let reviewLightboxPhotos = [];
    let reviewLightboxIndex = 0;
    let reviewLightboxAlt = '';
    let isFetchingMoreReviews = false;
    let hasHydratedJudgeMeReviews = false;
    const loadedReviewIds = new Set(
      reviewsTrack
        ? [...reviewsTrack.querySelectorAll('[data-owa-review-slide]')]
            .map((node) => node.dataset.reviewId)
            .filter(Boolean)
        : []
    );

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (char) => {
        switch (char) {
          case '&':
            return '&amp;';
          case '<':
            return '&lt;';
          case '>':
            return '&gt;';
          case '"':
            return '&quot;';
          case "'":
            return '&#39;';
          default:
            return char;
        }
      });

    const getReviewSlides = () => (reviewsTrack ? [...reviewsTrack.querySelectorAll('[data-owa-review-slide]')] : []);
    const getLoadedReviewCount = () => getReviewSlides().length;
    const hasMoreReviews = () => getLoadedReviewCount() < totalReviewCount;

    const updateReviewsLoadedState = () => {
      if (reviewsLoadedState) {
        reviewsLoadedState.textContent = `${getLoadedReviewCount()} van ${totalReviewCount} beoordelingen geladen`;
      }

      if (reviewsLoadMoreBtn) {
        const showButton = hasMoreReviews();
        reviewsLoadMoreBtn.hidden = !showButton;
        reviewsLoadMoreBtn.disabled = isFetchingMoreReviews;
        reviewsLoadMoreBtn.textContent = isFetchingMoreReviews ? 'Beoordelingen laden...' : 'Meer beoordelingen laden';
      }
    };

    const getReviewGap = () => {
      if (!reviewsTrack) return 0;
      const styles = window.getComputedStyle(reviewsTrack);
      return Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    };

    const getReviewPageMeta = () => {
      const slides = getReviewSlides();
      if (!reviewsTrack || !slides.length) return { positions: [], pageSize: 1 };
      const gap = getReviewGap();
      const firstSlide = slides[0];
      const slideWidth = firstSlide.getBoundingClientRect().width;
      const trackWidth = reviewsTrack.getBoundingClientRect().width;
      const pageSize = Math.max(1, Math.min(slides.length, Math.floor((trackWidth + gap + 2) / (slideWidth + gap))));
      const positions = [];
      for (let index = 0; index < slides.length; index += pageSize) {
        positions.push(slides[index].offsetLeft);
      }
      return { positions, pageSize };
    };

    const syncReviewNavigation = () => {
      const slides = getReviewSlides();
      if (!reviewsTrack || !slides.length) {
        if (reviewsNav) reviewsNav.hidden = true;
        updateReviewsLoadedState();
        return;
      }

      const { positions } = getReviewPageMeta();
      const totalLoadedPages = positions.length || 1;
      const currentLeft = reviewsTrack.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      positions.forEach((position, index) => {
        const distance = Math.abs(position - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      currentReviewPage = closestIndex;
      if (reviewsNav) reviewsNav.hidden = totalLoadedPages <= 1 && !hasMoreReviews();
      if (reviewsPagination) reviewsPagination.textContent = `${closestIndex + 1} / ${totalLoadedPages}`;
      if (reviewsPrevBtn) {
        reviewsPrevBtn.disabled = closestIndex === 0 || isFetchingMoreReviews;
        reviewsPrevBtn.setAttribute('aria-disabled', String(reviewsPrevBtn.disabled));
      }
      if (reviewsNextBtn) {
        const atLoadedEnd = closestIndex >= totalLoadedPages - 1;
        reviewsNextBtn.disabled = isFetchingMoreReviews || (atLoadedEnd && !hasMoreReviews());
        reviewsNextBtn.setAttribute('aria-disabled', String(reviewsNextBtn.disabled));
      }
      updateReviewsLoadedState();
    };

    const scrollReviewsToPage = (targetPage) => {
      const slides = getReviewSlides();
      if (!reviewsTrack || !slides.length) return;
      const { positions } = getReviewPageMeta();
      if (!positions.length) return;
      currentReviewPage = Math.max(0, Math.min(targetPage, positions.length - 1));
      reviewsTrack.scrollTo({ left: positions[currentReviewPage], behavior: 'smooth' });
      window.requestAnimationFrame(() => window.requestAnimationFrame(syncReviewNavigation));
    };

    const formatReviewDate = (value) => {
      if (!value) return '';
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return value;
      return new Intl.DateTimeFormat('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
        .format(parsed)
        .replace(/\//g, '-');
    };

    const parseJudgeMeReviewNode = (reviewNode) => {
      if (!reviewNode) return null;
      const id = reviewNode.dataset.reviewId || reviewNode.getAttribute('data-review-id') || '';
      const author = reviewNode.querySelector('.jdgm-rev__author')?.textContent?.trim() || 'Anonieme klant';
      const title = reviewNode.querySelector('.jdgm-rev__title')?.textContent?.trim() || '';
      const bodyHtml = reviewNode.querySelector('.jdgm-rev__body')?.innerHTML?.trim() || '';
      const rating = Number.parseInt(reviewNode.querySelector('.jdgm-rev__rating')?.dataset.score || '0', 10) || 0;
      const date = reviewNode.querySelector('.jdgm-rev__timestamp')?.dataset.content?.trim() || '';
      const photos = [...reviewNode.querySelectorAll('.jdgm-rev__pic-link')]
        .map((link) => {
          const image = link.querySelector('img');
          const original =
            link.getAttribute('href') ||
            link.getAttribute('data-mfp-src') ||
            image?.getAttribute('src') ||
            image?.getAttribute('data-src') ||
            '';
          const preview =
            image?.getAttribute('src') ||
            image?.getAttribute('data-src') ||
            link.getAttribute('href') ||
            link.getAttribute('data-mfp-src') ||
            '';
          if (!original) return null;
          return { original, preview };
        })
        .filter(Boolean);

      return {
        id,
        author,
        title,
        bodyHtml,
        rating,
        date,
        photos,
      };
    };

    const setReviewCardExpandedState = (reviewCard, expanded) => {
      if (!reviewCard) return;
      const readMoreButton = reviewCard.querySelector('[data-owa-review-read-more]');
      reviewCard.classList.toggle('is-expanded', expanded);
      if (readMoreButton) {
        readMoreButton.setAttribute('aria-expanded', String(expanded));
        readMoreButton.textContent = expanded
          ? readMoreButton.dataset.labelLess || 'Lees minder'
          : readMoreButton.dataset.labelMore || 'Lees meer';
      }
      window.requestAnimationFrame(syncReviewNavigation);
    };

    const syncReviewCardReadMore = (reviewCard) => {
      if (!reviewCard) return;
      const reviewBody = reviewCard.querySelector('.owa-pdp__review-body');
      const readMoreButton = reviewCard.querySelector('[data-owa-review-read-more]');
      if (!reviewBody || !readMoreButton) return;

      const wasExpanded = reviewCard.classList.contains('is-expanded');
      if (wasExpanded) {
        reviewCard.classList.remove('is-expanded');
      }

      readMoreButton.hidden = true;
      readMoreButton.setAttribute('aria-expanded', 'false');
      readMoreButton.textContent = readMoreButton.dataset.labelMore || 'Lees meer';

      const isTruncated = reviewBody.scrollHeight - reviewBody.clientHeight > 4;

      if (!isTruncated) {
        reviewCard.classList.remove('is-expanded');
        return;
      }

      readMoreButton.hidden = false;

      if (wasExpanded) {
        reviewCard.classList.add('is-expanded');
        readMoreButton.setAttribute('aria-expanded', 'true');
        readMoreButton.textContent = readMoreButton.dataset.labelLess || 'Lees minder';
      }
    };

    const syncAllReviewCardsReadMore = () => {
      getReviewSlides().forEach((reviewCard) => syncReviewCardReadMore(reviewCard));
    };

    const createReviewCardElement = (review) => {
      const reviewId = review.id || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const reviewAuthor = review.author || 'Anonieme klant';
      const reviewTitle = review.title || '';
      const reviewBodyHtml = review.bodyHtml || '';
      const reviewRating = Number(review.rating || 0);
      const reviewPhotos = Array.isArray(review.photos) ? review.photos : [];
      const hasMedia = reviewPhotos.length > 0;
      const reviewAlt = reviewTitle || reviewAuthor;
      const authorInitial = reviewAuthor.trim().charAt(0).toUpperCase() || 'A';
      const morePhotosCount = Math.max(0, reviewPhotos.length - 4);
      const starsHtml = Array.from({ length: 5 }, (_, index) => {
        return `<span class="owa-pdp__review-star${index + 1 <= reviewRating ? ' is-active' : ''}">★</span>`;
      }).join('');
      const thumbsHtml = reviewPhotos
        .slice(1, 4)
        .map((photo, index) => {
          return `<button type="button" class="owa-pdp__review-thumb" data-owa-review-photo-open data-owa-review-photo-index="${index + 1}" aria-label="Open extra reviewfoto ${index + 1}">
            <img src="${escapeHtml(photo.preview || photo.original)}" alt="${escapeHtml(reviewAlt)}" loading="lazy" width="112" height="112">
          </button>`;
        })
        .join('');
      const moreThumbHtml =
        morePhotosCount > 0
          ? `<button type="button" class="owa-pdp__review-thumb owa-pdp__review-thumb--more" data-owa-review-photo-open data-owa-review-photo-index="1" aria-label="Bekijk alle reviewfoto's">+${morePhotosCount}</button>`
          : '';
      const mediaHtml = hasMedia
        ? `<div class="owa-pdp__review-media">
            <button type="button" class="owa-pdp__review-photo-main" data-owa-review-photo-open data-owa-review-photo-index="0" aria-label="Open reviewfoto van ${escapeHtml(reviewAuthor)}">
              <img src="${escapeHtml(reviewPhotos[0].original || reviewPhotos[0].preview)}" srcset="${escapeHtml(
                `${reviewPhotos[0].preview || reviewPhotos[0].original} 160w, ${reviewPhotos[0].original || reviewPhotos[0].preview} 1024w`
              )}" sizes="(max-width: 749px) calc(100vw - 58px), (min-width: 1280px) 24rem, 34rem" alt="${escapeHtml(reviewAlt)}" loading="lazy" width="560" height="420">
            </button>
            ${
              reviewPhotos.length > 1
                ? `<div class="owa-pdp__review-thumbs">${thumbsHtml}${moreThumbHtml}</div>`
                : ''
            }
          </div>`
        : '';
      const titleHtml = reviewTitle ? `<h3 class="owa-pdp__review-title">${escapeHtml(reviewTitle)}</h3>` : '';
      const bodyHtml = reviewBodyHtml ? reviewBodyHtml : '<p></p>';
      const readMoreHtml = `<button type="button" class="owa-pdp__review-read-more" data-owa-review-read-more data-label-more="Lees meer" data-label-less="Lees minder" aria-expanded="false" hidden>Lees meer</button>`;
      const dateHtml = review.date ? `<span class="owa-pdp__review-date">${escapeHtml(formatReviewDate(review.date))}</span>` : '';

      const template = document.createElement('template');
      template.innerHTML = `
        <article class="owa-pdp__review-card ${hasMedia ? 'has-media' : 'is-text-only'}" data-owa-review-slide data-review-id="${escapeHtml(reviewId)}" data-owa-review-photos="${escapeHtml(
          reviewPhotos.map((photo) => photo.original).join('|||')
        )}" data-owa-review-photo-alt="${escapeHtml(reviewAlt)}">
          ${mediaHtml}
          <div class="owa-pdp__review-rating-row">
            <span class="owa-pdp__review-stars" aria-label="${escapeHtml(`${reviewRating} van 5 sterren`)}">${starsHtml}</span>
            <span class="owa-pdp__review-rating-score">${escapeHtml(`${reviewRating}/5`)}</span>
          </div>
          ${titleHtml}
          <div class="owa-pdp__review-body">${bodyHtml}</div>
          ${readMoreHtml}
          <footer class="owa-pdp__review-meta">
            <div class="owa-pdp__review-author-block">
              <span class="owa-pdp__review-author-initial" aria-hidden="true">${escapeHtml(authorInitial)}</span>
              <div class="owa-pdp__review-author-copy">
                <span class="owa-pdp__review-author">${escapeHtml(reviewAuthor)}</span>
                ${dateHtml}
              </div>
            </div>
          </footer>
        </article>
      `;

      return template.content.firstElementChild;
    };

    const parseJudgeMeHtmlToReviews = (html) => {
      if (!html) return [];
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(html, 'text/html');
      return [...documentFragment.querySelectorAll('.jdgm-rev')].map(parseJudgeMeReviewNode).filter(Boolean);
    };

    const appendReviewsToTrack = (reviews, { replace = false } = {}) => {
      if (!reviewsTrack || !Array.isArray(reviews) || !reviews.length) return 0;

      if (replace) {
        reviewsTrack.innerHTML = '';
        loadedReviewIds.clear();
      }

      const fragment = document.createDocumentFragment();
      let appendedCount = 0;

      reviews.forEach((review) => {
        if (!review) return;
        const reviewId = review.id || '';
        if (reviewId && loadedReviewIds.has(reviewId)) return;
        const reviewNode = createReviewCardElement(review);
        fragment.appendChild(reviewNode);
        if (reviewId) loadedReviewIds.add(reviewId);
        appendedCount += 1;
      });

      if (appendedCount) {
        reviewsTrack.appendChild(fragment);
        syncAllReviewCardsReadMore();
      }

      return appendedCount;
    };

    const buildJudgeMeRequestUrl = (pageNumber) => {
      const endpointUrl = new URL(reviewsEndpoint || 'https://api.judge.me/reviews/reviews_for_widget', window.location.origin);
      endpointUrl.searchParams.set('url', reviewsShopDomain);
      endpointUrl.searchParams.set('shop_domain', reviewsShopDomain);
      endpointUrl.searchParams.set('platform', 'shopify');
      endpointUrl.searchParams.set('page', String(pageNumber));
      endpointUrl.searchParams.set('per_page', String(reviewsBatchSize));
      endpointUrl.searchParams.set('product_id', String(reviewsProductId));
      return endpointUrl.toString();
    };

    const fetchJudgeMeReviewPage = async (pageNumber, { replace = false } = {}) => {
      if (!reviewsTrack || !reviewsEndpoint || !reviewsShopDomain || !reviewsProductId || isFetchingMoreReviews) return 0;
      isFetchingMoreReviews = true;
      reviewsTrack.setAttribute('aria-busy', 'true');
      updateReviewsLoadedState();
      syncReviewNavigation();

      try {
        const response = await fetch(buildJudgeMeRequestUrl(pageNumber), {
          method: 'GET',
          credentials: 'omit',
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Judge.me response ${response.status}`);
        }

        const payload = await response.json();
        const parsedReviews = parseJudgeMeHtmlToReviews(payload.html || '');
        if (!parsedReviews.length && replace) {
          throw new Error('Judge.me returned no reviews for the initial hydrate');
        }

        if (payload.total_count) {
          totalReviewCount = Number.parseInt(payload.total_count, 10) || totalReviewCount;
          if (reviewsSection) reviewsSection.dataset.owaReviewsTotalCount = String(totalReviewCount);
        }

        const appendedCount = appendReviewsToTrack(parsedReviews, { replace });
        if (appendedCount > 0 || replace) {
          currentJudgeMePage = Number.parseInt(payload.page, 10) || pageNumber;
          hasHydratedJudgeMeReviews = true;
          if (replace) {
            currentReviewPage = 0;
            reviewsTrack.scrollLeft = 0;
          }
        }

        return appendedCount;
      } catch (error) {
        console.error('OWA Judge.me reviews hydrate failed', error);
        return 0;
      } finally {
        isFetchingMoreReviews = false;
        reviewsTrack.removeAttribute('aria-busy');
        updateReviewsLoadedState();
        syncReviewNavigation();
      }
    };

    const maybeLoadMoreReviews = async () => {
      if (!reviewsTrack || isFetchingMoreReviews || !hasMoreReviews()) return false;
      const nearEndThreshold = Math.max(160, reviewsTrack.clientWidth * 0.4);
      if (reviewsTrack.scrollLeft + reviewsTrack.clientWidth < reviewsTrack.scrollWidth - nearEndThreshold) {
        return false;
      }

      const appendedCount = await fetchJudgeMeReviewPage(currentJudgeMePage + 1);
      return appendedCount > 0;
    };

    const hydrateJudgeMeReviews = async () => {
      if (!reviewsTrack || !reviewsEndpoint || !reviewsShopDomain || !reviewsProductId || hasHydratedJudgeMeReviews) {
        updateReviewsLoadedState();
        syncReviewNavigation();
        return;
      }

      const hydratedCount = await fetchJudgeMeReviewPage(1, { replace: true });
      if (!hydratedCount) {
        currentJudgeMePage = 1;
        updateReviewsLoadedState();
        syncReviewNavigation();
      }
    };

    if (reviewsTrack && getReviewSlides().length) {
      syncAllReviewCardsReadMore();
      syncReviewNavigation();
      const resizeObserver = new ResizeObserver(() => {
        syncAllReviewCardsReadMore();
        syncReviewNavigation();
      });
      resizeObserver.observe(reviewsTrack);

      reviewsTrack.addEventListener('click', (event) => {
        const readMoreButton = event.target.closest('[data-owa-review-read-more]');
        if (!readMoreButton) return;
        const reviewCard = readMoreButton.closest('[data-owa-review-slide]');
        if (!reviewCard) return;
        setReviewCardExpandedState(reviewCard, !reviewCard.classList.contains('is-expanded'));
        syncReviewCardReadMore(reviewCard);
      });

      reviewsPrevBtn?.addEventListener('click', () => {
        scrollReviewsToPage(currentReviewPage - 1);
      });

      reviewsNextBtn?.addEventListener('click', async () => {
        const { positions } = getReviewPageMeta();
        const lastLoadedPage = Math.max(0, positions.length - 1);

        if (currentReviewPage >= lastLoadedPage && hasMoreReviews()) {
          const appended = await fetchJudgeMeReviewPage(currentJudgeMePage + 1);
          if (appended > 0) {
            scrollReviewsToPage(currentReviewPage + 1);
            return;
          }
        }

        scrollReviewsToPage(currentReviewPage + 1);
      });

      reviewsLoadMoreBtn?.addEventListener('click', async () => {
        await fetchJudgeMeReviewPage(currentJudgeMePage + 1);
      });

      reviewsTrack.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(reviewScrollRaf);
          reviewScrollRaf = window.requestAnimationFrame(() => {
            syncReviewNavigation();
            void maybeLoadMoreReviews();
          });
        },
        { passive: true }
      );

      let reviewDragState = null;
      const stopReviewDrag = () => {
        if (!reviewDragState) return;
        reviewsTrack.classList.remove('is-dragging');
        if (reviewDragState.pointerId != null && reviewsTrack.releasePointerCapture) {
          try {
            reviewsTrack.releasePointerCapture(reviewDragState.pointerId);
          } catch (error) {
            void error;
          }
        }
        const moved = reviewDragState.moved;
        reviewDragState = null;
        syncReviewNavigation();
        if (moved) scrollReviewsToPage(currentReviewPage);
      };

      reviewsTrack.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a')) return;
        reviewDragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScrollLeft: reviewsTrack.scrollLeft,
          moved: false,
        };
        reviewsTrack.classList.add('is-dragging');
        if (reviewsTrack.setPointerCapture) {
          try {
            reviewsTrack.setPointerCapture(event.pointerId);
          } catch (error) {
            void error;
          }
        }
      });

      reviewsTrack.addEventListener('pointermove', (event) => {
        if (!reviewDragState || event.pointerId !== reviewDragState.pointerId) return;
        const delta = event.clientX - reviewDragState.startX;
        if (Math.abs(delta) > 4) reviewDragState.moved = true;
        reviewsTrack.scrollLeft = reviewDragState.startScrollLeft - delta;
      });

      reviewsTrack.addEventListener('pointerup', stopReviewDrag);
      reviewsTrack.addEventListener('pointercancel', stopReviewDrag);
      reviewsTrack.addEventListener('pointerleave', stopReviewDrag);

      void hydrateJudgeMeReviews();
    } else if (reviewsNav) {
      reviewsNav.hidden = true;
    }

    const syncReviewLightbox = () => {
      if (!reviewsLightboxImage || !reviewLightboxPhotos.length) return;
      const safeIndex = Math.max(0, Math.min(reviewLightboxIndex, reviewLightboxPhotos.length - 1));
      const totalPhotos = reviewLightboxPhotos.length;
      reviewsLightboxImage.src = reviewLightboxPhotos[safeIndex];
      reviewsLightboxImage.alt = reviewLightboxAlt ? `${reviewLightboxAlt} ${safeIndex + 1}` : `Reviewfoto ${safeIndex + 1}`;
      if (reviewsLightboxCaption) reviewsLightboxCaption.textContent = reviewLightboxAlt || 'Reviewfoto';
      if (reviewsLightboxCount) reviewsLightboxCount.textContent = `${safeIndex + 1} / ${totalPhotos}`;
      if (reviewsLightboxPrev) reviewsLightboxPrev.disabled = totalPhotos <= 1;
      if (reviewsLightboxNext) reviewsLightboxNext.disabled = totalPhotos <= 1;
    };

    const openReviewLightbox = (card, index) => {
      if (!reviewsLightbox || !card) return;
      const photoData = String(card.dataset.owaReviewPhotos || '')
        .split('|||')
        .map((photo) => photo.trim())
        .filter(Boolean);
      if (!photoData.length) return;

      reviewLightboxPhotos = photoData;
      reviewLightboxIndex = Math.max(0, Math.min(index, photoData.length - 1));
      reviewLightboxAlt = card.dataset.owaReviewPhotoAlt || '';
      lockBodyScroll('reviews-lightbox');
      reviewsLightbox.classList.add('is-open');
      reviewsLightbox.setAttribute('aria-hidden', 'false');
      syncReviewLightbox();
    };

    const closeReviewLightbox = () => {
      if (!reviewsLightbox) return;
      reviewsLightbox.classList.remove('is-open');
      reviewsLightbox.setAttribute('aria-hidden', 'true');
      reviewLightboxPhotos = [];
      reviewLightboxIndex = 0;
      reviewLightboxAlt = '';
      reviewsLightboxImage?.removeAttribute('src');
      unlockBodyScroll('reviews-lightbox');
    };

    const stepReviewLightbox = (direction) => {
      if (!reviewLightboxPhotos.length) return;
      reviewLightboxIndex = (reviewLightboxIndex + direction + reviewLightboxPhotos.length) % reviewLightboxPhotos.length;
      syncReviewLightbox();
    };

    reviewsSection?.addEventListener('click', (event) => {
      const reviewPhotoButton = event.target.closest('[data-owa-review-photo-open]');
      if (!reviewPhotoButton || !reviewsSection.contains(reviewPhotoButton)) return;
      event.preventDefault();
      const reviewCard = reviewPhotoButton.closest('[data-owa-review-slide]');
      const photoIndex = Number(reviewPhotoButton.dataset.owaReviewPhotoIndex || 0);
      openReviewLightbox(reviewCard, photoIndex);
    });

    reviewsLightboxClose?.addEventListener('click', closeReviewLightbox);
    reviewsLightboxPrev?.addEventListener('click', () => stepReviewLightbox(-1));
    reviewsLightboxNext?.addEventListener('click', () => stepReviewLightbox(1));
    reviewsLightbox?.addEventListener('click', (event) => {
      if (event.target === reviewsLightbox) closeReviewLightbox();
    });

    document.addEventListener('keydown', (event) => {
      if (reviewsLightbox?.classList.contains('is-open')) {
        if (event.key === 'Escape') closeReviewLightbox();
        if (event.key === 'ArrowLeft') stepReviewLightbox(-1);
        if (event.key === 'ArrowRight') stepReviewLightbox(1);
      }
    });
    /* ── Countdown timer ── */
    const cdEl = sectionRoot.querySelector('[data-owa-countdown]');
    if (cdEl) {
      const endDate = new Date(cdEl.dataset.end).getTime();
      const daysEl = cdEl.querySelector('[data-owa-cd-days]');
      const hrsEl = cdEl.querySelector('[data-owa-cd-hours]');
      const minsEl = cdEl.querySelector('[data-owa-cd-mins]');
      const secsEl = cdEl.querySelector('[data-owa-cd-secs]');
      const tick = () => {
        const diff = Math.max(0, endDate - Date.now());
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        daysEl.textContent = String(d).padStart(2, '0');
        hrsEl.textContent = String(h).padStart(2, '0');
        minsEl.textContent = String(m).padStart(2, '0');
        secsEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) { clearInterval(cdTimer); cdEl.style.display = 'none'; }
      };
      tick();
      const cdTimer = setInterval(tick, 1000);
    }

    /* ── Sticky Add to Cart bar ── */
    const stickyBar = sectionRoot.querySelector('[data-owa-sticky-bar]');
    const stickyAtcBtn = sectionRoot.querySelector('[data-owa-sticky-atc]');
    const buyboxSidebar = container.querySelector('.owa-pdp__sidebar');

    if (stickyBar && addButton) {
      let stickyRaf = null;
      let hasScrolledPastButton = false;
      const desktopMedia = window.matchMedia('(min-width: 990px)');
      const mobileMedia = window.matchMedia('(max-width: 749px)');

      const updateStickyVisibility = () => {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const stickyTriggerRect = (buyboxSidebar || container).getBoundingClientRect();
        const addButtonRect = addButton.getBoundingClientRect();
        const desktopOffset = 120;
        const mobileOffset = 0;
        const isDesktop = desktopMedia.matches;
        const isMobile = mobileMedia.matches;
        const topOffset = isDesktop ? desktopOffset : mobileOffset;
        const bottomOffset = isDesktop ? 32 : 16;
        const hasEnteredTriggerZone = stickyTriggerRect.top <= topOffset;
        const addButtonVisible =
          addButtonRect.bottom > topOffset &&
          addButtonRect.top < viewportHeight - bottomOffset;
        const visible = isDesktop
          ? hasEnteredTriggerZone && !addButtonVisible
          : hasScrolledPastButton && !addButtonVisible;

        stickyBar.classList.toggle('is-visible', visible);
        const w = document.querySelector('.owa-widget');
        if (w) {
          w.style.transition = 'bottom 0.3s ease';
          if (visible && isMobile) {
            w.style.zIndex = '999999';
            w.style.bottom = '11rem';
          } else {
            w.style.zIndex = '';
            w.style.bottom = '';
          }
        }
      };

      const requestStickyUpdate = () => {
        if (stickyRaf) cancelAnimationFrame(stickyRaf);
        stickyRaf = requestAnimationFrame(() => {
          stickyRaf = null;
          updateStickyVisibility();
        });
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === addButton && entry.isIntersecting) {
            hasScrolledPastButton = true;
          }
        });
        requestStickyUpdate();
      }, { threshold: [0, 0.25, 0.75, 1] });
      observer.observe(addButton);
      if (buyboxSidebar) observer.observe(buyboxSidebar);

      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate);
      desktopMedia.addEventListener?.('change', requestStickyUpdate);
      mobileMedia.addEventListener?.('change', requestStickyUpdate);
      requestStickyUpdate();

      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', () => {
          addButton.click();
        });
      }
    }
  }

  function initWithin(root) {
    if (!root) return;

    if (root.matches && root.matches('[data-owa-product-section]')) {
      initOwaProductPageReplica(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-owa-product-section]').forEach(initOwaProductPageReplica);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document));
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initWithin(event.target);
  });
})();
